<template>
    <form class="product-order-form" action="" method="post" ref="orderForm">
        <DuplicateOrderModal
            ref="duplicateOrdersModal"
            :duplicate-orders="duplicateOrders"
            @continue="validateAndCreateOrder"
        />

        <ShopStatePopup ref="shopStatePopup" :email="customerMail" />

        <NoticePopup
            ref="noticePopup"
            :title="$t('shop.product_unavailable_popup_title')"
            :text="this.noticePopupText"
            @close="redirectHome"
        />

        <input type="hidden" name="customer_outside_austria" :value="this.customer_outside_austria" />
        <input type="hidden" name="product_id" :value="selectedProduct" />
        <input type="hidden" name="product_type" :value="selectedProductType" />
        <input type="hidden" name="voucher_code" :value="this.voucher.code" v-if="this.voucher !== null" />
        <div class="row d-none" id="product-form">
            <div class="col-md-4">
                <h4 class="mt-0 mb-4">{{ $t('shop.right_of_withdrawal_title') }}</h4>
            </div>
            <div class="col-md-8 mb-2">
                <div
                    v-if="selectedProductType === 'vignette' || selectedProductType === 'route_toll'"
                    class="col-12 mt-4 mt-md-0"
                >
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <label v-if="countOfAvailableRegisterOptions > 1">{{
                                    $t('shop.please_select_register_method')
                                }}</label>

                                <div
                                    v-if="
                                        typeof disableRightOfWithdrawalCompany !== 'boolean' ||
                                        !disableRightOfWithdrawalCompany
                                    "
                                    class="col-12"
                                    :class="{
                                        'mx-md-auto':
                                            typeof disableRightOfWithdrawal === 'boolean' && disableRightOfWithdrawal,
                                    }"
                                >
                                    <div class="checkbox-button-container">
                                        <input
                                            type="radio"
                                            class="checkbox"
                                            id="no-right-of-withdrawal"
                                            name="right_of_withdrawal"
                                            value="false"
                                            v-model="rightOfWithdrawal"
                                            required
                                            @change="
                                                updateDatePicker();
                                                inputChange('right_of_withdrawal');
                                                saveToSession('right_of_withdrawal', 'string', rightOfWithdrawal);
                                            "
                                        />
                                        <label
                                            for="no-right-of-withdrawal"
                                            class="label btn btn-block same-height"
                                            :class="noRightOfWithdrawalClass"
                                        >
                                            <span class="h5">{{ $t('shop.no_right_of_withdrawal') }}</span>
                                            <br />-<br />
                                            <p class="small info-text">
                                                {{ $t('shop.no_right_of_withdrawal_info') }}
                                            </p>
                                        </label>
                                    </div>
                                </div>

                                <div
                                    v-if="typeof disableRightOfWithdrawal !== 'boolean' || !disableRightOfWithdrawal"
                                    class="col-12"
                                    :class="{
                                        'mx-md-auto':
                                            typeof disableRightOfWithdrawalCompany === 'boolean' &&
                                            disableRightOfWithdrawalCompany,
                                    }"
                                >
                                    <div class="checkbox-button-container">
                                        <input
                                            type="radio"
                                            class="checkbox"
                                            id="right-of-withdrawal"
                                            name="right_of_withdrawal"
                                            value="true"
                                            v-model="rightOfWithdrawal"
                                            required
                                            @change="
                                                updateDatePicker();
                                                inputChange('right_of_withdrawal');
                                                saveToSession('right_of_withdrawal', 'string', rightOfWithdrawal);
                                            "
                                        />
                                        <label
                                            for="right-of-withdrawal"
                                            class="label btn btn-block same-height"
                                            :class="rightOfWithdrawalClass"
                                        >
                                            <span class="h5">{{ $t('shop.right_of_withdrawal') }}</span>
                                            <br />-<br />
                                            <p class="small info-text">
                                                {{ $t('shop.right_of_withdrawal_info') }}
                                            </p>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12" :class="{ 'disable-form-col': null === rightOfWithdrawal }">
                    <div class="row">
                        <div class="col-12 route-toll-col" v-if="selectedProductType === 'route_toll'">
                            <div class="row">
                                <div class="col-xs-12 col-md-6">
                                    <div class="form-group">
                                        <label class="col-form-label" for="toll_product">
                                            {{ $t('shop.route') }}
                                        </label>
                                        <select
                                            name="product_id"
                                            id="toll_product"
                                            class="form-control"
                                            ref="routeTollProduct"
                                            @change="
                                                displayRouteOptions(false);
                                                inputChange('product_id');
                                                saveToSession('toll_product', 'string', selectedRoute);
                                            "
                                            :class="{ 'is-invalid': formErrors.product_id }"
                                            v-model="selectedRoute"
                                            required
                                        >
                                            <option disabled value="0" v-if="this.defaultSelectedOption === 0" selected>
                                                {{ $t('shop.dropdown_required') }}
                                            </option>
                                            <option
                                                :value="tollProduct.id"
                                                :key="tollProduct.id"
                                                v-for="tollProduct in tollProducts"
                                            >
                                                {{ tollProduct.name }}
                                            </option>
                                        </select>
                                        <div class="invalid-feedback">
                                            <span class="d-block" v-for="error in formErrors.product_id" :key="error">{{
                                                error
                                            }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-md-6" v-if="selectedRoute">
                                    <div class="form-group">
                                        <label class="col-form-label" for="toll_option">
                                            {{ $t('shop.option') }}
                                        </label>
                                        <select
                                            name="option_id"
                                            id="toll_option"
                                            class="form-control"
                                            ref="routeTollOptions"
                                            required
                                            :class="{ 'is-invalid': formErrors.option_id }"
                                            v-model="selectedTollOption"
                                            @change="
                                                displayRouteTollValidityRange();
                                                inputChange('option_id');
                                                saveToSession('option_id', 'string', selectedTollOption);
                                                $emit('price-change', availableTollOptions[selectedTollOption].price);
                                                $emit(
                                                    'service-fee-change',
                                                    availableTollOptions[selectedTollOption].service_fee
                                                );
                                                $emit('insurance-fee-change', 0);
                                                resetRouteTollValidityIfNullable();
                                            "
                                        >
                                            <option disabled value="0" selected>
                                                {{ $t('shop.dropdown_required') }}
                                            </option>
                                            <option
                                                :value="option.id"
                                                :key="option.id"
                                                v-for="option in availableTollOptions"
                                                :price="option.price.toFixed(2)"
                                                :service-fee="option.service_fee.toFixed(2)"
                                            >
                                                {{ option.name }}
                                            </option>
                                        </select>
                                        <div class="invalid-feedback">
                                            <span class="d-block" v-for="error in formErrors.option_id" :key="error">{{
                                                error
                                            }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="col-12"
                                    v-if="
                                        selectedTollOption &&
                                        availableTollOptions[selectedTollOption].is_validity_controllable
                                    "
                                >
                                    <div class="form-group">
                                        <label class="col-form-label" for="valid_from">
                                            {{ $t('shop.validity_start') }}
                                        </label>
                                        <div class="datepicker-overlay">
                                            <DatePicker
                                                id="valid_from"
                                                name="validity_start"
                                                required="required"
                                                :config="datePickerOptions"
                                                @dp-change="
                                                    displayRouteTollValidityRange();
                                                    inputChange('validity_start');
                                                "
                                                @close="
                                                    setVignetteValidFromNullSetting = false;
                                                    routeTollValidityStartNotice = null;
                                                "
                                                v-model="routeTollValidityStart"
                                                :class="{ 'is-invalid': formErrors.validity_start }"
                                                ref="validityStart"
                                                @dp-invalid-date="showInvalidValidityStartMessage($event)"
                                                :disable-placeholder="setVignetteValidFromNullSetting"
                                            >
                                            </DatePicker>
                                            <div class="invalid-feedback">
                                                <div v-if="formErrors.validity_start && !routeTollValidityStart">
                                                    {{ $t('shop.validity_from_input_empty_error') }}
                                                </div>
                                                <div v-else>
                                                    <span
                                                        class="d-block"
                                                        v-for="error in formErrors.validity_start"
                                                        :key="error"
                                                    >
                                                        {{ error }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="invalid-validity-start" v-if="routeTollValidityStartNotice">
                                            <span class="d-block" v-html="routeTollValidityStartNotice"></span>
                                        </div>
                                        <div class="invalid-validity-start" v-if="vignetteValidFromNotice">
                                            <span class="d-block" v-html="vignetteValidFromNotice"></span>
                                        </div>
                                        <span v-if="vignetteValidTo" class="d-block mt-2"
                                            >{{ $t('shop.validity_end') }} {{ vignetteValidTo }}</span
                                        >
                                    </div>
                                </div>
                                <div class="col-12 text-center" v-else-if="routeTollValidityStart">
                                    <div class="route-toll-valid-from mt-2 h5">
                                        <span class="prefix-label">{{ $t('shop.validity_start') }}</span>
                                        <span class="to-date-label">{{
                                            splitDateTime(routeTollValidityStart).date
                                        }}</span>
                                        <span class="to-time-label">{{
                                            splitDateTime(routeTollValidityStart).time
                                        }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="background-container">

        <section
            class="section container mobile-product bg-after-rounded-100 section-offset-small section-scroll-with-offset"
            :id="$t('shop.productAnchor')"
        >
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h2>{{ $t('shop.selected_product') }}</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 mb-2">
                        <div class="selected-product-row pb-1">
                            <h3
                                class="text-primary"
                                v-html="
                                    selectedProductType === 'route_toll'
                                        ? $t('shop.toll-product')
                                        : selectedProduct
                                          ? products[selectedProduct].name
                                          : $t('shop.selected_product_choose')
                                "
                            ></h3>
                            <p
                                v-html="
                                    selectedProductType === 'route_toll'
                                        ? $t('shop.toll-product-description')
                                        : selectedProduct
                                          ? products[selectedProduct].description
                                          : $t('shop.selected_product_description')
                                "
                            ></p>
                            <a
                                class="toggle-package-change clickable"
                                :class="
                                    (selectedProductType !== 'route_toll' && selectedProduct <= 0) || showPackageChange
                                        ? 'turned'
                                        : ''
                                "
                                @click="togglePackageChange"
                                >{{ $t('shop.selected_product_change') }} <i class="mdi mdi-chevron-down"></i
                            ></a>
                        </div>

                        <div
                            class="row shop-pricing"
                            v-if="!showPackageChange && this.selectedProduct && this.selectedShopProduct && isMobile"
                        >
                            <div class="col-lg-3 my-lg-0 col-md-6 my-md-1 vignette">
                                <VignetteProductCard
                                    v-bind="this.selectedShopProduct"
                                    :options="this.selectedShopProduct.options"
                                    :key="this.selectedShopProduct.id"
                                    :smaller-view="false"
                                    :ref="'product-card-' + this.selectedShopProduct.id"
                                    :selected-product="selectedProduct"
                                    :url-name="this.selectedShopProduct.url_name"
                                    :url-names="this.selectedShopProduct.urls"
                                    :config-value="currentOrderValue"
                                    v-on:product-card-selected="changeSelection"
                                    :selected-product-type="selectedProductType"
                                    :show-price="showPriceInProductCard"
                                ></VignetteProductCard>
                            </div>
                        </div>

                        <div
                            class="row shop-pricing"
                            :class="{
                                'd-none': !(
                                    (selectedProductType !== 'route_toll' && selectedProduct <= 0) ||
                                    showPackageChange
                                ),
                            }"
                        >
                            <div
                                v-for="product in visibleProducts"
                                :key="product.id"
                                class="col-lg-3 my-lg-0 col-md-6 my-md-1 vignette"
                            >
                                <VignetteProductCard
                                    v-bind="product"
                                    :smaller-view="false"
                                    :ref="'product-card-' + product.id"
                                    :config-value="currentOrderValue"
                                    :selected-product="selectedProduct"
                                    :url-name="product.url_name"
                                    :url-names="product.urls"
                                    :preselect-id="
                                        defaultSelectedProduct !== null &&
                                        defaultSelectedProduct.productType === 'vignette' &&
                                        selectedProductType !== 'route_toll'
                                            ? defaultSelectedProduct.id
                                            : null
                                    "
                                    v-on:product-card-selected="changeSelection"
                                    :selected-product-type="selectedProductType"
                                    :notice-popup="product.noticePopup"
                                    :show-price="showPriceInProductCard"
                                ></VignetteProductCard>
                            </div>

                            <div v-if="showRouteTollCard" class="col-lg-3 my-lg-0 col-md-6 my-md-1 route-toll">
                                <TollProductCard
                                    :selected-product="selectedProduct"
                                    :preselect-id="
                                        defaultSelectedProduct !== null &&
                                        defaultSelectedProduct.productType === 'route_toll'
                                    "
                                    :url-name="routeTollProduct.url_name"
                                    :url-names="routeTollProduct.urls"
                                    v-on:product-card-selected="changeSelection"
                                    :selected-product-type="selectedProductType"
                                    :smaller-view="false"
                                    :config-value="currentOrderValue"
                                    :start-price="tollProductsStartPrice"
                                    :notice-popup="null"
                                    :show-price="showPriceInProductCard"
                                ></TollProductCard>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </div>

        <section class="section container" ref="formFields" id="route-toll-fields" v-if="selectedProductType === 'route_toll'">
            <div>
                <div class="row">
                    <div class="col-md-12">
                        <h2>{{ $t('shop.selected_route') }}</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 mb-2 route-toll-col">
                        <div class="row">
                            <div class="col-xs-12 col-md-6">
                                <div class="form-group mb-2">
                                    <label class="col-form-label" for="toll_product">
                                        {{ $t('shop.route') }}
                                    </label>
                                    <select
                                        name="product_id"
                                        id="toll_product"
                                        class="form-control"
                                        ref="routeTollProduct"
                                        @change="
                                            displayRouteOptions(false);
                                            inputChange('product_id');
                                            saveToSession('toll_product', 'string', selectedRoute);
                                        "
                                        :class="{ 'is-invalid': formErrors.product_id }"
                                        v-model="selectedRoute"
                                        required
                                    >
                                        <option disabled value="0" v-if="this.defaultSelectedOption === 0" selected>
                                            {{ $t('shop.dropdown_required') }}
                                        </option>
                                        <option
                                            :value="tollProduct.id"
                                            :key="tollProduct.id"
                                            v-for="tollProduct in tollProducts"
                                        >
                                            {{ tollProduct.name }}
                                        </option>
                                    </select>
                                    <div class="invalid-feedback">
                                        <span class="d-block" v-for="error in formErrors.product_id" :key="error">{{
                                            error
                                        }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-md-6" v-if="selectedRoute">
                                <div class="form-group mb-2">
                                    <label class="col-form-label" for="toll_option">
                                        {{ $t('shop.option') }}
                                    </label>
                                    <select
                                        name="option_id"
                                        id="toll_option"
                                        class="form-control"
                                        ref="routeTollOptions"
                                        required
                                        :class="{ 'is-invalid': formErrors.option_id }"
                                        v-model="selectedTollOption"
                                        @change="
                                            updateOrderFormSettings('route_toll');
                                            displayRouteTollValidityRange();
                                            inputChange('option_id');
                                            saveToSession('option_id', 'string', selectedTollOption);
                                            $emit('price-change', availableTollOptions[selectedTollOption].price);
                                            $emit(
                                                'service-fee-change',
                                                availableTollOptions[selectedTollOption].service_fee
                                            );
                                            $emit('insurance-fee-change', 0);
                                            updateDatePicker();
                                            resetRouteTollValidityIfNullable();
                                        "
                                    >
                                        <option disabled value="0" selected>{{ $t('shop.dropdown_required') }}</option>
                                        <option
                                            :value="option.id"
                                            :key="option.id"
                                            v-for="option in availableTollOptions"
                                            :price="option.price.toFixed(2)"
                                            :service-fee="option.service_fee.toFixed(2)"
                                        >
                                            {{ option.name }}
                                        </option>
                                    </select>
                                    <div class="invalid-feedback">
                                        <span class="d-block" v-for="error in formErrors.option_id" :key="error">{{
                                            error
                                        }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div
                                v-if="
                                    selectedRoute &&
                                    typeof tollProducts[selectedRoute].info === 'string' &&
                                    tollProducts[selectedRoute].info.trim().length > 0
                                "
                                class="col-12"
                            >
                                <div class="row align-items-center mb-2 bg-light rounded px-0 p-5 border-primary">
                                    <div class="col-md-2">
                                        <i class="mdi mdi-exclamation status-icon status-icon-warning"></i>
                                    </div>
                                    <div class="col-md-10">
                                        <h4
                                            class="mb-0 mb-mobile mobile-text-center"
                                            v-html="$t('shop.attention_route_toll')"
                                        ></h4>
                                        <span class="text-quote mobile-text-center">
                                            <p v-html="tollProducts[selectedRoute].info"></p>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div
                                class="col-12"
                                v-if="
                                    selectedTollOption &&
                                    availableTollOptions[selectedTollOption].is_validity_controllable
                                "
                            >
                                <div class="form-group mb-2">
                                    <label class="col-form-label" for="valid_from">
                                        {{ $t('shop.validity_start') }}
                                    </label>
                                    <div class="datepicker-overlay">
                                        <DatePicker
                                            id="valid_from"
                                            name="validity_start"
                                            required="required"
                                            :config="datePickerOptions"
                                            @dp-change="
                                                displayRouteTollValidityRange();
                                                inputChange('validity_start');
                                            "
                                            @close="setVignetteValidFromNullSetting = false"
                                            v-model="routeTollValidityStart"
                                            :class="{ 'is-invalid': formErrors.validity_start }"
                                            ref="routeTollValidityStart"
                                            @dp-invalid-date="showInvalidValidityStartMessage($event)"
                                            :disable-placeholder="setVignetteValidFromNullSetting"
                                        >
                                        </DatePicker>
                                        <div class="invalid-feedback">
                                            <div v-if="formErrors.validity_start && !routeTollValidityStart">
                                                {{ $t('shop.validity_from_input_empty_error') }}
                                            </div>
                                            <div v-else>
                                                <span
                                                    class="d-block"
                                                    v-for="error in formErrors.validity_start"
                                                    :key="error"
                                                >
                                                    {{ error }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="invalid-validity-start" v-if="vignetteValidFromNotice">
                                        <span class="d-block" v-html="vignetteValidFromNotice"></span>
                                    </div>
                                    <span
                                        v-if="vignetteValidTo"
                                        class="d-block mt-2 mt-0 h5 bg-light rounded py-2 text-center"
                                        >{{ $t('shop.validity_end') }} {{ vignetteValidTo }}</span
                                    >
                                </div>
                            </div>
                            <div class="col-12 text-center" v-else-if="routeTollValidityStart">
                                <div class="route-toll-valid-from mt-0 h5 bg-light rounded py-2">
                                    <span class="prefix-label">{{ $t('shop.validity_start') }}</span>
                                    <span class="to-date-label">{{ splitDateTime(routeTollValidityStart).date }}</span>
                                    <span class="to-time-label">{{ splitDateTime(routeTollValidityStart).time }}</span>
                                    <template v-if="routeTollValidityEnd">
                                        -
                                        <span class="to-date-label">{{
                                            splitDateTime(routeTollValidityEnd).date
                                        }}</span>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section container" ref="formFields" id="vignette-fields" v-if="selectedProductType === 'vignette'">
            <div>
                <div class="row">
                    <div class="col-md-12">
                        <h2>{{ $t('shop.selected_validity_vehicle') }}</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 mb-2 vignette-col">
                        <div class="row">
                            <div class="col-12" v-if="this.products[this.selectedProduct].is_validity_controllable">
                                <div class="form-group mb-2">
                                    <label class="col-form-label" for="valid_from">
                                        {{ $t('shop.validity_start') }}
                                    </label>
                                    <div class="datepicker-overlay">
                                        <DatePicker
                                            id="valid_from"
                                            name="validity_start"
                                            required="required"
                                            :config="datePickerOptions"
                                            :mobileIcon="true"
                                            @dp-change="
                                                displayTypeOptions();
                                                inputChange('validity_start');
                                            "
                                            @close="
                                                setVignetteValidFromNullSetting = false;
                                                vignetteValidFromNotice = null;
                                            "
                                            :class="{ 'is-invalid': formErrors.validity_start }"
                                            v-model="vignetteValidFrom"
                                            ref="vignetteValidFrom"
                                            @dp-invalid-date="showInvalidValidityStartMessage($event)"
                                            :disable-placeholder="setVignetteValidFromNullSetting"
                                        >
                                        </DatePicker>
                                        <div class="invalid-feedback">
                                            <div v-if="formErrors.validity_start && !vignetteValidFrom">
                                                {{ $t('shop.validity_from_input_empty_error') }}
                                            </div>
                                            <div v-else>
                                                <span
                                                    class="d-block"
                                                    v-for="error in formErrors.validity_start"
                                                    :key="error"
                                                >
                                                    {{ error }}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="invalid-validity-start" v-if="showSelectedValidityStartError">
                                            <span class="d-block">
                                                {{ $t('shop.validityStartError') }}
                                            </span>
                                        </div>
                                        <div class="invalid-validity-start" v-if="vignetteValidFromNotice">
                                            <span class="d-block" v-html="vignetteValidFromNotice"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="vignetteValidTo" class="col-12 text-center">
                                <div class="vignette-validity-until mt-0 mb-4 h5 bg-light rounded py-2">
                                    <span class="prefix-label">{{ $t('shop.validityPrefix') }}</span>
                                    <span class="from-label">{{ vignetteValidFrom }}</span>
                                    <span class="separator-label">{{ $t('shop.validitySeparator') }}</span>
                                    <span class="to-date-label">{{ splitDateTime(vignetteValidTo).date }}</span>
                                    <span class="to-time-label">{{ splitDateTime(vignetteValidTo).time }}</span>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label class="d-block">{{ $t('shop.vehicle_type') }}</label>
                                    <div class="row justify-content-center">
                                        <div
                                            v-for="vignetteOption in sortedVignetteOptions"
                                            :key="vignetteOption.id"
                                            class="col-12 col-md-6 mb-2"
                                            :class="{
                                                'text-md-right': 0 === getIndexForVignetteOption(vignetteOption.id),
                                            }"
                                        >
                                            <div class="checkbox-button-container">
                                                <input
                                                    type="radio"
                                                    class="checkbox"
                                                    name="option_id"
                                                    :value="vignetteOption.id"
                                                    :id="'vignette_option_' + vignetteOption.id"
                                                    :class="{ 'is-invalid': formErrors.option_id }"
                                                    :price="vignetteOption.price.toFixed(2)"
                                                    @change="
                                                        updateOrderFormSettings('vignette');
                                                        inputChange('option_id');
                                                        saveToSession('option_id', 'string', selectedVignetteOption);
                                                        $emit(
                                                            'price-change',
                                                            vignetteOptions[selectedVignetteOption].price
                                                        );
                                                        $emit(
                                                            'service-fee-change',
                                                            vignetteOptions[selectedVignetteOption].service_fee
                                                        );
                                                        $emit(
                                                            'insurance-fee-change',
                                                            vignetteOptions[selectedVignetteOption].insurance_fee
                                                        );
                                                        updateDatePicker();
                                                    "
                                                    v-model="selectedVignetteOption"
                                                    required
                                                />
                                                <label
                                                    :for="'vignette_option_' + vignetteOption.id"
                                                    class="mb-0 shop-product-card alternative bg-white px-4 py-2 rounded text-center text-reset-case"
                                                    :class="{
                                                        highlighted: vignetteOption.id === selectedVignetteOption,
                                                    }"
                                                >
                                                    <i
                                                        class="mdi h5 mr-1"
                                                        :class="{
                                                            'mdi-car': 'car' === vignetteOption.vehicle_type,
                                                            'mdi-motorbike': 'bike' === vignetteOption.vehicle_type,
                                                        }"
                                                    ></i>
                                                    <h2 class="title mt-2 mb-0">
                                                        {{ $t('shop.vehicle_' + vignetteOption.vehicle_type) }}
                                                    </h2>
                                                    <small
                                                        class="mt-1 mb-0"
                                                        v-if="
                                                            $te(
                                                                'vehicleTypes.' +
                                                                    vignetteOption.vehicle_type +
                                                                    '_description'
                                                            )
                                                        "
                                                        v-t="
                                                            'vehicleTypes.' +
                                                            vignetteOption.vehicle_type +
                                                            '_description'
                                                        "
                                                    >
                                                    </small>
                                                    <!--
                                                    <div class="d-flex justify-content-center">
                                                        <span v-if="vignetteOption.price > 0" class="price h1 mb-0">({{ (vignetteOption.price + vignetteOption.service_fee).toFixed(2) }} €)</span>
                                                    </div>
                                                    -->
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section container" ref="orderContainer" v-if="this.selectedProduct > 0">
            <div id="orderContainer">
                <div class="row">
                    <div class="col-md-12">
                        <h2>{{ $t('shop.selected_country_license') }}</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 mb-2 order-container-col">
                        <div class="row">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group w-100">
                                            <label class="col-form-label" for="country_code">
                                                {{ $t('shop.licensing_state') }}
                                            </label>
                                            <select
                                                name="country_code"
                                                id="country_code"
                                                :class="{ 'is-invalid': formErrors.country_code }"
                                                class="form-control height-auto-override"
                                                v-model="selectedCountry"
                                                @change="
                                                    inputChange('country_code');
                                                    saveToSession('country_code', 'string', selectedCountry);
                                                "
                                                required
                                            >
                                                <option disabled value="false" selected>
                                                    {{ $t('shop.dropdown_required') }}
                                                </option>
                                                <option
                                                    v-for="templateOption in sortedLicensePlateTemplates"
                                                    :key="templateOption.country_code"
                                                    :value="templateOption.country_code"
                                                    :data-name="templateOption.country_name"
                                                >
                                                    {{ $t('country.' + templateOption.country_code) }}
                                                </option>
                                            </select>
                                            <div v-if="missingLicensePlateTooltipActive" class="form-text text-muted">
                                                <small>
                                                    <a
                                                        ref="licensePlateTooltip"
                                                        class="tooltip-info"
                                                        href="#"
                                                        onclick="return false;"
                                                        data-toggle="popover"
                                                        data-trigger="focus"
                                                        data-placement="right"
                                                        data-html="true"
                                                        :data-content="$t('shop.missing_license_plate_content')"
                                                        v-html="$t('shop.missing_license_plate_button')"
                                                    ></a>
                                                </small>
                                            </div>
                                        </div>
                                        <div
                                            class="row"
                                            v-for="templateOption in selectedLicensePlateTemplates"
                                            :key="templateOption.country_code"
                                            :class="templateOption.country_code + '-row'"
                                        >
                                            <div class="col-12 col-lg-6">
                                                <div
                                                    class="form-group"
                                                    :class="{ 'mb-2': templateOption.allows_multilicenseplate }"
                                                >
                                                    <label class="col-form-label" for="license_plate">
                                                        {{ $t('shop.license_plate') }}
                                                    </label>
                                                    <LicensePlateInput
                                                        :license-plate-country="templateOption"
                                                        :template="templateOption.template"
                                                        :required="true"
                                                        :is-invalid="
                                                            typeof formErrors.license === 'object' &&
                                                            formErrors.license.length > 0
                                                        "
                                                        name="license"
                                                        id="license_plate"
                                                        @input="
                                                            resetLicensePlateStatus();
                                                            parseLicensePlateInput(false);
                                                            inputChange('license');
                                                            saveToSession('license', 'string', licensePlate);
                                                        "
                                                        @has-license-plate-template="hasTemplateForm = $event"
                                                        @license-plate-check-status="handleLicensePlateCheckEmitStatus"
                                                        @is-special-changed="handleIsSpecial"
                                                        :special-license-plate-error="
                                                            formErrors.special_license_plate_confirmed || null
                                                        "
                                                        v-model="licensePlate"
                                                    >
                                                        <span
                                                            class="d-block"
                                                            v-for="error in formErrors.license"
                                                            :key="error"
                                                            >{{ error }}</span
                                                        >
                                                    </LicensePlateInput>
                                                </div>
                                            </div>
                                            <div class="col-12 col-lg-6">
                                                <div
                                                    class="form-group"
                                                    :class="{ 'mb-2': templateOption.allows_multilicenseplate }"
                                                >
                                                    <label class="col-form-label" for="license_plate_confirm">
                                                        {{ $t('shop.license_plate_confirm') }}
                                                    </label>
                                                    <LicensePlateInput
                                                        :disable-validation="true"
                                                        :license-plate-country="templateOption"
                                                        :template="templateOption.template"
                                                        :required="true"
                                                        :is-invalid="
                                                            typeof formErrors.license_confirmation === 'object' &&
                                                            formErrors.license_confirmation.length > 0
                                                        "
                                                        name="license_confirmation"
                                                        id="license_plate_confirm"
                                                        @input="
                                                            resetLicensePlateStatus();
                                                            parseLicensePlateInput(true);
                                                            inputChange('license_confirm');
                                                            saveToSession(
                                                                'license_confirm',
                                                                'string',
                                                                licensePlateConfirm
                                                            );
                                                        "
                                                        @has-license-plate-template="hasTemplateForm = $event"
                                                        @is-special-changed="handleIsSpecial"
                                                        v-model="licensePlateConfirm"
                                                    >
                                                        <span
                                                            class="d-block"
                                                            v-for="error in formErrors.license_confirmation"
                                                            :key="error"
                                                            >{{ error }}</span
                                                        >
                                                    </LicensePlateInput>
                                                </div>
                                            </div>
                                            <div v-if="licensePlateShowError" class="ml-3 text-danger">
                                                {{ $t('shop.licensePlateLiveValidationError') }}
                                            </div>
                                            <div v-if="templateOption.allows_multilicenseplate" class="col-12">
                                                <div class="custom-control custom-switch">
                                                    <div class="form-group">
                                                        <input
                                                            type="checkbox"
                                                            class="custom-control-input"
                                                            name="is_multilicenseplate"
                                                            id="field_is_multilicenseplate"
                                                            value="1"
                                                        />
                                                        <label
                                                            class="custom-control-label font-weight-normal"
                                                            for="field_is_multilicenseplate"
                                                        >
                                                            {{ $t('shop.is_multilicenseplate') }}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section container" ref="contactDetails" v-if="this.selectedProduct > 0">
            <div>
                <div class="row">
                    <div class="col-md-12">
                        <h2>{{ $t('shop.selected_contact_details') }}</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 order-container-col">
                        <div class="row">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <label for="paypal-first_name">
                                                {{ $t('shop.paypal_first_name') }}
                                            </label>
                                            <input
                                                type="text"
                                                name="paypal_first_name"
                                                class="form-control"
                                                id="paypal-first_name"
                                                :placeholder="$t('shop.first_name_placeholder')"
                                                :class="{ 'is-invalid': formErrors.paypal_first_name }"
                                                @change="
                                                    inputChange('paypal_first_name');
                                                    saveToSession(
                                                        'paypal_first_name',
                                                        'string',
                                                        getValueFromInput('paypal_first_name')
                                                    );
                                                "
                                                @keydown="inputChange('paypal_first_name')"
                                                required
                                            />
                                            <div class="invalid-feedback">
                                                <span
                                                    class="d-block"
                                                    v-for="error in formErrors.paypal_first_name"
                                                    :key="error"
                                                    >{{ error }}</span
                                                >
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <label for="paypal-last_name">
                                                {{ $t('shop.paypal_last_name') }}
                                            </label>
                                            <input
                                                type="text"
                                                name="paypal_last_name"
                                                class="form-control"
                                                id="paypal-last_name"
                                                :placeholder="$t('shop.last_name_placeholder')"
                                                @change="
                                                    inputChange('paypal_last_name');
                                                    saveToSession(
                                                        'paypal_last_name',
                                                        'string',
                                                        getValueFromInput('paypal_last_name')
                                                    );
                                                "
                                                @keydown="inputChange('paypal_last_name')"
                                                :class="{ 'is-invalid': formErrors.paypal_last_name }"
                                                required
                                            />
                                            <div class="invalid-feedback">
                                                <span
                                                    class="d-block"
                                                    v-for="error in formErrors.paypal_last_name"
                                                    :key="error"
                                                    >{{ error }}</span
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="email">
                                                {{ $t('shop.email') }}
                                            </label>
                                            <input
                                                type="email"
                                                name="email"
                                                class="form-control"
                                                id="email"
                                                :placeholder="$t('shop.email_placeholder')"
                                                @change="
                                                    inputChange('email');
                                                    saveToSession('email', 'string', getValueFromInput('email'));
                                                "
                                                @keydown="inputChange('email')"
                                                :class="{ 'is-invalid': formErrors.email }"
                                                v-model="customerMail"
                                                required
                                            />
                                            <div class="invalid-feedback">
                                                <span class="d-block" v-for="error in formErrors.email" :key="error">{{
                                                    error
                                                }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div v-if="whatsAppServiceActive" class="col-12">
                                        <div class="row">
                                            <div class="col-4 col-md-3">
                                                <div class="form-group">
                                                    <label for="phone-code">{{ $t('shop.phone_code') }}</label>
                                                    <select
                                                        id="phone-code"
                                                        name="phone_code"
                                                        class="form-control"
                                                        v-model="selectedPhoneCode"
                                                        ref="countryPhoneCode"
                                                        @change="
                                                            saveToSession('phone_code', 'string', selectedPhoneCode)
                                                        "
                                                    >
                                                        <option disabled value="false" selected>
                                                            {{ $t('shop.dropdown_required') }}
                                                        </option>
                                                        <option
                                                            v-for="templateOption in countryCodePhones"
                                                            :key="templateOption.phone_code"
                                                            :value="templateOption.phone_code"
                                                            :data-country="templateOption.country_code"
                                                        >
                                                            {{
                                                                $t('shop.phone_code_option', {
                                                                    code: templateOption.phone_code,
                                                                    country: $t(
                                                                        'country.' + templateOption.country_code
                                                                    ),
                                                                })
                                                            }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-8 col-md-9">
                                                <div
                                                    class="form-group"
                                                    v-for="templateOption in selectedCountryCodePhones"
                                                    :key="templateOption.phone_code"
                                                >
                                                    <div class="inner" :class="{ 'mb-1': whatsAppServiceActive }">
                                                        <label for="phone">
                                                            {{ $t('shop.phone') }}
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="phone"
                                                            class="form-control"
                                                            id="phone"
                                                            :placeholder="templateOption.placeholder"
                                                            @change="
                                                                inputChange('phone');
                                                                saveToSession('phone', 'string', phoneNumber);
                                                            "
                                                            :class="{ 'is-invalid': formErrors.phone }"
                                                            v-model="phoneNumber"
                                                            required
                                                        />
                                                        <div class="invalid-feedback">
                                                            <span
                                                                class="d-block"
                                                                v-for="error in formErrors.phone"
                                                                :key="error"
                                                                >{{ error }}</span
                                                            >
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row custom-control-switch-row">
                            <div v-if="this.expiryOfRightOfWithdrawalActive" class="col-12">
                                <div class="custom-control custom-switch">
                                    <div class="form-group mb-1">
                                        <input
                                            class="custom-control-input"
                                            name="residence_in_austria"
                                            type="checkbox"
                                            value="1"
                                            id="residence_in_austria"
                                            v-model="residenceInAustria"
                                        />
                                        <label
                                            class="custom-control-label font-weight-normal"
                                            for="residence_in_austria"
                                            v-html="$t('shop.residenceInAustria')"
                                        >
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div v-if="whatsAppServiceActive" class="col-12">
                                <div class="custom-control custom-switch">
                                    <div class="form-group mb-1">
                                        <input
                                            class="custom-control-input"
                                            name="whatsapp_status"
                                            type="checkbox"
                                            value="1"
                                            id="whatsapp_message"
                                            @change="
                                                inputChange('whatsapp_status');
                                                saveToSession('whatsapp_status', 'string', selectedWhatsApp);
                                            "
                                            v-model="selectedWhatsApp"
                                        />
                                        <label
                                            class="custom-control-label font-weight-normal"
                                            for="whatsapp_message"
                                            v-html="
                                                $t('shop.whatsapp_message', {
                                                    price: whatsAppServicePrice.toFixed(2),
                                                })
                                            "
                                        >
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="custom-control custom-switch">
                                            <div class="form-group mb-1">
                                                <input
                                                    class="custom-control-input"
                                                    name="invoice_wanted"
                                                    type="checkbox"
                                                    value="1"
                                                    id="invoice_wanted"
                                                    @change="
                                                        inputChange('invoice_wanted');
                                                        saveToSession('invoice_wanted', 'string', invoiceWanted);
                                                        selectedInvoicePerPost = false;
                                                    "
                                                    v-model="invoiceWanted"
                                                />
                                                <label
                                                    class="custom-control-label font-weight-normal"
                                                    for="invoice_wanted"
                                                    v-html="$t('shop.invoice_wanted')"
                                                >
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="invoicePostActive" class="col-12">
                                <div class="custom-control custom-switch">
                                    <!-- :class="{ 'disabled-element': ! invoiceWanted }" -->
                                    <div class="form-group mb-1">
                                        <input
                                            class="custom-control-input"
                                            name="invoice_per_post"
                                            type="checkbox"
                                            value="1"
                                            id="invoice_per_post"
                                            @change="
                                                inputChange('invoice_per_post');
                                                saveToSession('invoice_per_post', 'string', selectedInvoicePerPost);
                                            "
                                            v-model="selectedInvoicePerPost"
                                        />
                                        <label
                                            class="custom-control-label font-weight-normal"
                                            for="invoice_per_post"
                                            v-html="
                                                $t('shop.invoice_per_post', {
                                                    price: invoicePostPrice.toFixed(2),
                                                })
                                            "
                                        >
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <div v-if="invoiceWanted" class="row mt-3">
                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <label for="first_name">
                                                {{ $t('shop.first_name') }}
                                            </label>
                                            <input
                                                type="text"
                                                name="first_name"
                                                class="form-control"
                                                id="first_name"
                                                :placeholder="$t('shop.first_name_placeholder')"
                                                :class="{ 'is-invalid': formErrors.first_name }"
                                                @change="
                                                    inputChange('first_name');
                                                    saveToSession(
                                                        'first_name',
                                                        'string',
                                                        getValueFromInput('first_name')
                                                    );
                                                "
                                                @keydown="inputChange('first_name')"
                                                required
                                            />
                                            <div class="invalid-feedback">
                                                <span
                                                    class="d-block"
                                                    v-for="error in formErrors.first_name"
                                                    :key="error"
                                                    >{{ error }}</span
                                                >
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <label for="last_name">
                                                {{ $t('shop.last_name') }}
                                            </label>
                                            <input
                                                type="text"
                                                name="last_name"
                                                class="form-control"
                                                id="last_name"
                                                :placeholder="$t('shop.last_name_placeholder')"
                                                @change="
                                                    inputChange('last_name');
                                                    saveToSession(
                                                        'last_name',
                                                        'string',
                                                        getValueFromInput('last_name')
                                                    );
                                                "
                                                @keydown="inputChange('last_name')"
                                                :class="{ 'is-invalid': formErrors.last_name }"
                                                required
                                            />
                                            <div class="invalid-feedback">
                                                <span
                                                    class="d-block"
                                                    v-for="error in formErrors.last_name"
                                                    :key="error"
                                                    >{{ error }}</span
                                                >
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="street">
                                                {{ $t('shop.company') }}
                                            </label>
                                            <input
                                                type="text"
                                                name="company"
                                                class="form-control"
                                                id="company"
                                                :placeholder="$t('shop.company_placeholder')"
                                                @change="
                                                    inputChange('company');
                                                    saveToSession('company', 'string', getValueFromInput('company'));
                                                "
                                                @keydown="inputChange('company')"
                                                :class="{ 'is-invalid': formErrors.company }"
                                            />
                                            <div class="invalid-feedback">
                                                <span
                                                    class="d-block"
                                                    v-for="error in formErrors.company"
                                                    :key="error"
                                                    >{{ error }}</span
                                                >
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-8">
                                        <div class="form-group">
                                            <label for="street">
                                                {{ $t('shop.street') }}
                                            </label>
                                            <input
                                                type="text"
                                                name="street"
                                                class="form-control"
                                                id="street"
                                                :placeholder="$t('shop.street_placeholder')"
                                                @change="
                                                    inputChange('street');
                                                    saveToSession('street', 'string', getValueFromInput('street'));
                                                "
                                                @keydown="inputChange('street')"
                                                :class="{ 'is-invalid': formErrors.street }"
                                                required
                                            />
                                            <div class="invalid-feedback">
                                                <span class="d-block" v-for="error in formErrors.street" :key="error">{{
                                                    error
                                                }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label for="house">
                                                {{ $t('shop.house_number') }}
                                            </label>
                                            <input
                                                type="text"
                                                name="house"
                                                class="form-control"
                                                id="house"
                                                :placeholder="$t('shop.house_number_placeholder')"
                                                @change="
                                                    inputChange('house');
                                                    saveToSession('house', 'string', getValueFromInput('house'));
                                                "
                                                @keydown="inputChange('house')"
                                                :class="{ 'is-invalid': formErrors.house }"
                                                required
                                            />
                                            <div class="invalid-feedback">
                                                <span class="d-block" v-for="error in formErrors.house" :key="error">{{
                                                    error
                                                }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label for="postcode">
                                                {{ $t('shop.postcode') }}
                                            </label>
                                            <input
                                                type="text"
                                                name="postcode"
                                                class="form-control"
                                                id="postcode"
                                                :placeholder="$t('shop.postcode_placeholder')"
                                                @change="
                                                    inputChange('postcode');
                                                    saveToSession('postcode', 'string', getValueFromInput('postcode'));
                                                "
                                                @keydown="inputChange('postcode')"
                                                :class="{ 'is-invalid': formErrors.postcode }"
                                                required
                                            />
                                            <div class="invalid-feedback">
                                                <span
                                                    class="d-block"
                                                    v-for="error in formErrors.postcode"
                                                    :key="error"
                                                    >{{ error }}</span
                                                >
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-8">
                                        <div class="form-group">
                                            <label for="city">
                                                {{ $t('shop.city') }}
                                            </label>
                                            <input
                                                type="text"
                                                name="city"
                                                class="form-control"
                                                id="city"
                                                :placeholder="$t('shop.city_placeholder')"
                                                @change="
                                                    inputChange('city');
                                                    saveToSession('city', 'string', getValueFromInput('city'));
                                                "
                                                @keydown="inputChange('city')"
                                                :class="{ 'is-invalid': formErrors.city }"
                                                required
                                            />
                                            <div class="invalid-feedback">
                                                <span class="d-block" v-for="error in formErrors.city" :key="error">{{
                                                    error
                                                }}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="country">
                                                {{ $t('shop.country') }}
                                            </label>
                                            <select
                                                name="country"
                                                id="country"
                                                :class="{ 'is-invalid': formErrors.country }"
                                                class="form-control"
                                                @change="
                                                    inputChange('country');
                                                    saveToSession('country', 'string', getValueFromInput('country'));
                                                "
                                                required
                                            >
                                                <option disabled value="false" selected>
                                                    {{ $t('shop.dropdown_required') }}
                                                </option>
                                                <option
                                                    v-for="templateOption in sortedLicensePlateTemplates"
                                                    :key="templateOption.country_name"
                                                    :value="templateOption.country_name"
                                                >
                                                    {{ $t('country.' + templateOption.country_code) }}
                                                </option>
                                            </select>
                                            <div class="invalid-feedback">
                                                <span
                                                    class="d-block"
                                                    v-for="error in formErrors.country"
                                                    :key="error"
                                                    >{{ error }}</span
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- /ROW -->
            </div>
        </section>
        <section
            class="section pb-0 container"
            ref="priceDetails"
            v-if="(selectedProductType !== 'route_toll' && selectedProduct > 0) || selectedProductType === 'route_toll'"
        >
            <div>
                <div class="row">
                    <div class="col-md-12 order-container-col mb-2">
                        <div v-if="showInsuranceInfo" class="row">
                            <div class="col-12">
                                <div
                                    class="align-items-center bg-light rounded px-0 p-5 border-primary p-mobile-small icon-text-container justify-content-start"
                                >
                                    <div class="row">
                                        <div class="col-12 col-lg-4 text-center">
                                            <div
                                                class="insurance-info-element align-items-center justify-content-between justify-content-md-center h-100"
                                            >
                                                <i
                                                    class="mdi mdi-shield-check insurance-info-icon ml-0 mr-0 ml-lg-0 without-opacity-update"
                                                ></i>
                                                <div class="insurance-info-tag ml-lg-4">
                                                    <div class="icon-text-container-title">
                                                        <span v-html="$t('shop.insuranceIncludedInfo')"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-12 col-lg-8">
                                            <div class="mt-1 mt-md-2 mt-lg-0">
                                                <h4
                                                    class="mb-3 text-center"
                                                    v-html="$t('shop.insuranceIncludedTitle')"
                                                ></h4>
                                                <span
                                                    class="d-block text-quote text-left text-md-center"
                                                    v-html="
                                                        $t('shop.insuranceIncludedText', {
                                                            insuranceTimeout: this.insuranceTimeout,
                                                        })
                                                    "
                                                >
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="showOrderInsurance" class="row">
                            <div class="col-12">
                                <label for="order_insurance" class="d-block mb-0">
                                    <IconTextContainer
                                        :with-title="true"
                                        :with-price-label="true"
                                        class="justify-content-lg-start"
                                        row-class="justify-content-md-center justify-content-lg-start"
                                    >
                                        <template v-slot:icon>
                                            <div
                                                class="d-flex align-items-center justify-content-between justify-content-md-center justify-content-lg-between h-100"
                                            >
                                                <div>
                                                    <input
                                                        type="checkbox"
                                                        class="checkbox"
                                                        id="order_insurance"
                                                        name="order_insurance"
                                                        :value="true"
                                                        v-model="orderInsurance"
                                                    />
                                                </div>
                                                <i
                                                    class="mdi mdi-shield-check insurance-icon ml-0 mr-0 ml-md-10 ml-lg-0 without-opacity-update"
                                                ></i>
                                            </div>
                                        </template>

                                        <template v-slot:title>
                                            <div class="d-flex align-items-center h-100">
                                                <span v-html="$t('shop.insuranceRecommendation')"></span>
                                            </div>
                                        </template>

                                        <div class="mt-1 mt-md-2 mt-lg-0">
                                            <h4 class="mb-3 text-center" v-html="$t('shop.insuranceInfoTitle')"></h4>
                                            <span
                                                v-if="getLastInsuranceDate"
                                                class="d-block text-quote text-left text-md-center"
                                                v-html="
                                                    $t('shop.insuranceInfoText', {
                                                        cancellationDate: getLastInsuranceDate,
                                                    })
                                                "
                                            ></span>
                                        </div>

                                        <template v-slot:price>
                                            <div
                                                class="d-flex align-items-center h-100 justify-content-center justify-content-lg-end mt-md-1 mt-lg-0"
                                            >
                                                <div class="d-flex align-items-baseline d-lg-block">
                                                    <h5 class="mb-0" v-html="$t('shop.insurancePriceTitle')"></h5>
                                                    <span class="ml-2 ml-lg-0 text-quote" style="font-size: 18px">{{
                                                        getInsuranceFee
                                                    }}</span>
                                                </div>
                                            </div>
                                        </template>
                                    </IconTextContainer>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div v-if="isSubscriptionEnabled" class="col-md-12 mb-2">
                        <div class="row">
                            <div class="col-12">
                                <label for="payment_subscription" class="d-block mb-0">
                                    <IconTextContainer
                                        :with-title="true"
                                        :title-without-price="true"
                                        class="justify-content-lg-start"
                                        row-class="justify-content-md-center justify-content-lg-start"
                                    >
                                        <template v-slot:icon>
                                            <div
                                                class="d-flex align-items-center justify-content-between justify-content-md-center justify-content-lg-between h-100"
                                            >
                                                <div>
                                                    <input
                                                        type="checkbox"
                                                        class="checkbox"
                                                        id="payment_subscription"
                                                        name="payment_subscription"
                                                        :value="true"
                                                        v-model="paymentSubscription"
                                                    />
                                                </div>
                                                <i
                                                    class="mdi mdi-calendar-sync payment_subscription-icon ml-0 mr-0 ml-md-10 ml-lg-0 without-opacity-update"
                                                ></i>
                                            </div>
                                        </template>

                                        <template v-slot:title>
                                            <div class="d-flex align-items-center h-100">
                                                <span v-html="$t('shop.insuranceRecommendation')"></span>
                                            </div>
                                        </template>

                                        <div class="mt-1 mt-md-2 mt-lg-0">
                                            <h4
                                                class="mb-3 text-center"
                                                v-html="$t('shop.paymentSubscriptionInfoTitle')"
                                            ></h4>
                                            <Tooltip class="subscription-info-tooltip" :only-click="true">
                                                <template #icon>
                                                    <i class="icon mdi mdi-information-outline"></i>
                                                </template>

                                                <template #text>
                                                    <h5 v-html="$t('shop.paymentSubscriptionInfoToolTipTitle')"></h5>
                                                    <div v-html="$t('shop.paymentSubscriptionInfoToolTipText')"></div>
                                                </template>
                                            </Tooltip>
                                            <span
                                                class="d-block text-quote text-left text-md-center"
                                                v-html="$t('order.paymentSubscriptionInfoText')"
                                            ></span>
                                        </div>
                                    </IconTextContainer>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 mb-2 route-toll-col">
                        <div class="summary-container bg-light rounded p-3 mt-3 mb-mobile-section">
                            <div class="row vertical-center">
                                <div class="col-md-6 px-5 py-3 mobile-padding">
                                    <div class="w-100 bg-transparent" v-if="selectedProduct > 0">
                                        <div class="card-body px-0 pt-0">
                                            <h4 class="mb-4 text-primary">{{ $t('shop.order_details') }}</h4>
                                            <div
                                                class="my-2"
                                                v-if="selectedProductType === 'route_toll' ? true : !!selectedProduct"
                                            >
                                                <b>{{ $t('shop.order_details') }}</b
                                                ><span class="float-right">{{
                                                    selectedProductType === 'route_toll'
                                                        ? $t('shop.toll-product')
                                                        : selectedProduct
                                                          ? products[selectedProduct].name
                                                          : $t('shop.selected_product_choose')
                                                }}</span
                                                ><br />
                                            </div>
                                            <div
                                                class="my-2"
                                                v-if="vignetteValidFrom && this.selectedProductType === 'vignette'"
                                            >
                                                <b>{{ $t('shop.order_valid_from') }}</b
                                                ><span class="float-right">{{ vignetteValidFrom }}</span
                                                ><br />
                                            </div>
                                            <div
                                                class="my-2"
                                                v-else-if="
                                                    routeTollValidityStart && this.selectedProductType === 'route_toll'
                                                "
                                            >
                                                <b>{{ $t('shop.order_valid_from') }}</b
                                                ><span class="float-right">{{ routeTollValidityStart }}</span
                                                ><br />
                                            </div>
                                            <div class="my-2" v-if="vignetteValidTo">
                                                <b>{{ $t('shop.order_valid_to') }}</b
                                                ><span class="float-right">{{ vignetteValidTo }}</span
                                                ><br />
                                            </div>
                                            <div class="my-2" v-if="licensePlate">
                                                <b>{{ $t('shop.license_plate') }}</b
                                                ><span class="float-right">{{ licensePlate }}</span
                                                ><br />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 px-5 py-3 mobile-padding">
                                    <div class="w-100 bg-transparent" v-if="selectedProduct > 0">
                                        <div class="card-body px-0 d-flex flex-column justify-content-center">
                                            <div v-if="detailedPriceDisplay && serviceFee > 0">
                                                <div class="row detailed-price-listing">
                                                    <div class="offset-lg-2"></div>
                                                    <div class="col-8 col-lg-6 text-left">
                                                        {{ $t('shop.detailedPriceTitleToll') }}
                                                    </div>
                                                    <div class="col-4 col-lg-4 text-right">
                                                        {{ orderPrice.toFixed(2) }} €
                                                    </div>
                                                </div>
                                                <div class="row detailed-price-listing">
                                                    <div class="offset-lg-2"></div>
                                                    <div
                                                        class="col-8 col-lg-6 text-left cursor-pointer"
                                                        @click.prevent="$refs.serviceFeePopup.onShowModal()"
                                                    >
                                                        {{ $t('shop.detailedPriceTitleService') }}
                                                    </div>
                                                    <div class="col-4 col-lg-4 text-right">
                                                        <ServiceFeeInfo
                                                            ref="serviceFeePopup"
                                                            v-if="showShopServiceFeePopup && !emAbo"
                                                            :service-fee="serviceFee - voucherDiscount"
                                                            :show-lang="false"
                                                        ></ServiceFeeInfo>
                                                    </div>
                                                </div>
                                                <div class="row detailed-price-listing" v-if="this.orderInsurance">
                                                    <div class="offset-lg-2"></div>
                                                    <div class="col-8 col-lg-6 text-left">
                                                        {{ $t('shop.detailedPriceTitleInsurance') }}
                                                    </div>
                                                    <div class="col-4 col-lg-4 text-right">
                                                        {{ insuranceFee.toFixed(2) }} €
                                                    </div>
                                                </div>
                                                <div class="row mb-1">
                                                    <div class="offset-7 offset-lg-8"></div>
                                                    <div class="col-5 col-lg-4">
                                                        <hr class="detailed-price-hr" />
                                                    </div>
                                                </div>
                                                <div class="row mb-3">
                                                    <div class="offset-lg-2"></div>
                                                    <div class="col-7 col-md-6 col-lg-6">
                                                        <div class="detailed-price-sum-title">
                                                            {{ $t('shop.detailedPriceTitleSum') }}
                                                        </div>
                                                    </div>
                                                    <div class="col-5 col-md-6 col-lg-4 text-right detailed-price-sum">
                                                        <template v-if="this.voucher !== null">
                                                            {{ getOrderPrice(2, true) }} €
                                                        </template>
                                                        <template v-else> {{ getOrderPrice(2) }} € </template>
                                                    </div>
                                                </div>
                                                <div class="row mb-3">
                                                    <div class="offset-lg-2"></div>
                                                    <div class="col-12 col-lg-10">
                                                        <form
                                                            action=""
                                                            method="post"
                                                            ref="voucherForm"
                                                            class="justify-content-center row"
                                                            @submit.prevent="submitVoucherForm"
                                                        >
                                                            <input
                                                                type="hidden"
                                                                name="product_id"
                                                                :value="selectedProduct"
                                                            />
                                                            <input
                                                                type="hidden"
                                                                name="product_type"
                                                                :value="selectedProductType"
                                                            />
                                                            <div
                                                                class="col-6 col-lg-8 px-3 px-md-0 px-lg-3 pt-0 form-group"
                                                                v-if="!voucher"
                                                            >
                                                                <input
                                                                    type="text"
                                                                    name="voucher_code"
                                                                    :placeholder="$t('shop.voucher_placeholder')"
                                                                    class="form-control"
                                                                    :disabled="loading || voucher"
                                                                    @change="
                                                                        inputChange('voucher_code');
                                                                        saveToSession(
                                                                            'voucher_code',
                                                                            'string',
                                                                            getValueFromInput('voucher_code')
                                                                        );
                                                                    "
                                                                    @keydown="inputChange('voucher_code')"
                                                                />
                                                            </div>
                                                            <div
                                                                class="col-6 col-lg-4 px-3 px-md-0 px-lg-3 pt-0 form-group text-right"
                                                                v-if="!voucher"
                                                            >
                                                                <button
                                                                    class="btn btn-primary shop-voucher-btn px-3"
                                                                    :disabled="loading"
                                                                    @click="
                                                                        $event.preventDefault();
                                                                        submitVoucherForm();
                                                                    "
                                                                >
                                                                    <span v-if="!loading && !voucher">{{
                                                                        $t('shop.voucherBtn')
                                                                    }}</span>
                                                                    <span v-if="loading">
                                                                        <i
                                                                            class="mdi mdi-spin mdi-loading mdi-18px"
                                                                        ></i>
                                                                    </span>
                                                                    <span v-if="voucher && !loading">
                                                                        <i class="mdi mdi-check mdi-18px"></i>
                                                                    </span>
                                                                </button>
                                                            </div>
                                                            <div
                                                                class="invalid-feedback d-block col-12 px-3 px-md-0 px-lg-3 pt-0"
                                                                v-if="voucherError"
                                                            >
                                                                <span class="d-block">
                                                                    {{ voucherError }}
                                                                </span>
                                                            </div>
                                                            <div
                                                                class="row detailed-price-listing text-primary form-group max-width"
                                                                v-if="voucherDiscount && voucher !== null"
                                                            >
                                                                <div
                                                                    class="col-12 col-lg-12 text-center font-weight-bold form-control"
                                                                >
                                                                    {{ voucherDiscount.toFixed(2) }} €
                                                                    {{ $t('shop.voucherApplied') }}
                                                                    <i
                                                                        class="mdi mdi-check mdi-18px price-listing-bold-icon"
                                                                    ></i>
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>

                                            <input type="hidden" name="order_timezone" :value="getOrderTimezone" />

                                            <div
                                                class="price-total w-100 text-center"
                                                v-if="!detailedPriceDisplay || serviceFee <= 0"
                                            >
                                                {{ $t('generic.price') }}:
                                                <div class="d-flex flex-row justify-content-center align-items-center">
                                                    <div
                                                        class="product-price line-height-32px"
                                                        v-if="this.voucher !== null"
                                                    >
                                                        {{ getOrderPrice(2, true) }} €
                                                    </div>
                                                    <div
                                                        class="product-price line-height-32px"
                                                        :class="{
                                                            old: this.voucher !== null,
                                                            'ml-2': this.voucher !== null,
                                                        }"
                                                    >
                                                        {{ getOrderPrice(2) }} €
                                                    </div>
                                                </div>
                                                <ServiceFeeInfo
                                                    v-if="showShopServiceFeePopup && !emAbo"
                                                    :service-fee="serviceFee - voucherDiscount"
                                                ></ServiceFeeInfo>
                                                <form
                                                    action=""
                                                    method="post"
                                                    ref="voucherForm"
                                                    class="row justify-content-center"
                                                    @submit.prevent="submitVoucherForm"
                                                >
                                                    <input type="hidden" name="product_id" :value="selectedProduct" />
                                                    <input
                                                        type="hidden"
                                                        name="product_type"
                                                        :value="selectedProductType"
                                                    />
                                                    <div class="form-group mb-2 mb-md-0 col-12 col-md-8">
                                                        <input
                                                            type="text"
                                                            name="voucher_code"
                                                            class="form-control"
                                                            :placeholder="$t('shop.voucher_placeholder')"
                                                            :class="{ 'is-invalid': voucherError !== '' }"
                                                            @change="
                                                                inputChange('voucher_code');
                                                                saveToSession(
                                                                    'voucher_code',
                                                                    'string',
                                                                    getValueFromInput('voucher_code')
                                                                );
                                                            "
                                                            @keydown="inputChange('voucher_code')"
                                                            @focusout="submitVoucherForm"
                                                        />
                                                        <div class="invalid-feedback">
                                                            <span class="d-block" v-if="voucherError">{{
                                                                voucherError
                                                            }}</span>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="checkboxesContainer w-100 bg-transparent mt-4" v-if="selectedProduct > 0">
                            <div class="card-body px-0 py-0" ref="tosAcceptedContainer">
                                <div class="row mb-2 checkbox-item">
                                    <div class="ml-4 ml-mobile-0 text-center">
                                        <input
                                            type="checkbox"
                                            class="checkbox"
                                            :class="asfinError ? 'checkbox-error' : ''"
                                            id="asfin_accepted"
                                            name="asfin_accepted"
                                            v-model="asfinAccepted"
                                        />
                                    </div>
                                    <div class="col-12 col-lg-11 text-justify pr-0 checkbox-text">
                                        <label class="smaller mb-0" for="asfin_accepted">
                                            <span v-html="$t('shop.asfin_checkbox_text')"></span>
                                        </label>
                                        <div class="invalid-feedback d-block" v-if="asfinError">
                                            <span class="d-block">{{ $t('shop.pre-order-warning') }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-2 checkbox-item">
                                    <div class="ml-4 ml-mobile-0 text-center">
                                        <input
                                            type="checkbox"
                                            class="checkbox"
                                            :class="tosError ? 'checkbox-error' : ''"
                                            id="tos_accepted"
                                            name="tos_accepted"
                                            v-model="tosAccepted"
                                        />
                                    </div>
                                    <div class="col-12 col-lg-11 text-justify pr-0 checkbox-text">
                                        <label class="smaller mb-0" for="tos_accepted">
                                            <span
                                                v-if="this.expiryOfRightOfWithdrawalActive"
                                                v-html="
                                                    this.showExpiryOfRightOfWithdrawal
                                                        ? $t('shop.expiryOfRightOfWithdrawal')
                                                        : $t('shop.pre-order-notice')
                                                "
                                            ></span>
                                            <span v-else v-html="$t('shop.expiryOfRightOfWithdrawal')"></span>
                                        </label>
                                        <div class="invalid-feedback d-block" v-if="tosError">
                                            <span class="d-block">{{ $t('shop.pre-order-warning') }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-2 checkbox-item" v-if="showLicenseRevocationCheckbox">
                                    <div class="ml-4 ml-mobile-0 text-center">
                                        <input
                                            type="checkbox"
                                            class="checkbox"
                                            :class="licenseRevocationError ? 'checkbox-error' : ''"
                                            id="license_revocation_accepted"
                                            name="license_revocation_accepted"
                                            v-model="licenseRevocationAccepted"
                                        />
                                    </div>
                                    <div class="col-12 col-lg-11 text-justify pr-0 checkbox-text">
                                        <label
                                            class="smaller mb-0"
                                            for="license_revocation_accepted"
                                            v-html="$t('shop.license_revocation_checkbox')"
                                        ></label>
                                        <div class="invalid-feedback d-block" v-if="licenseRevocationError">
                                            <span class="d-block">{{ $t('shop.pre-order-warning') }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-2 checkbox-item" v-if="showNewsletterCheckbox">
                                    <div class="ml-4 ml-mobile-0 text-center">
                                        <input
                                            type="checkbox"
                                            class="checkbox"
                                            :value="this.customerReceiveNewsletter"
                                            id="receive_newsletter"
                                            name="receive_newsletter"
                                            v-model="receiveNewsletter"
                                        />
                                    </div>
                                    <div class="col-12 col-lg-11 text-justify pr-0 checkbox-text">
                                        <label class="smaller mb-0" for="receive_newsletter">
                                            <span v-html="$t('shop.receive-newsletter')"></span>
                                            <span v-html="$t('shop.adsInfoText')"></span>
                                            <span
                                                @click.prevent="showUnsubscribeNewsletterModal()"
                                                v-html="$t('shop.unsubscribeNewsletterShopBtn')"
                                            >
                                            </span>
                                        </label>
                                    </div>
                                </div>
                                <div class="mb-4 ml-mobile-0 text-left">
                                    <span
                                        class="notice-payment-method-delivery-period smaller mb-0"
                                        v-html="$t('shop.additional_bank_transfer_info')"
                                    ></span>
                                </div>
                                <div class="row justify-content-center" ref="checkoutButton">
                                    <div class="col-12 col-md-5">
                                        <div class="checkbox-button-container">
                                            <button
                                                class="label btn btn-primary btn-block"
                                                :disabled="loading"
                                                @click="submitOrderForm"
                                                type="button"
                                            >
                                                <span class="h5">{{ $t('shop.order') }}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <PaymentMethods
                            class="payment-method-container same-margin-top offset-mobile-2"
                            :small="true"
                            @payment-method-changed="
                                paymentMethod = $event;
                                inputChange('payment_method');
                            "
                            v-if="paymentMethodSelectionAvailable && selectedProduct"
                        ></PaymentMethods>
                    </div>
                </div>
            </div>
        </section>

        <ShopLimitValidityModal
            v-if="limitValidityStart"
            ref="shopLimitValidityModal"
            :settings="settings"
            :customer-email="customerMail"
            :placeholders="limitValidityRangeForm.placeholders"
            :product-type="selectedProductType"
            :option-id="selectedTollOption !== 0 ? selectedTollOption : selectedVignetteOption"
            @declined="onValidityRangeDeclinedCallback($event)"
        />

        <UnsubscribeNewsletterModal ref="unsubscribeNewsletterModal" :customer-email="this.customerMail" />

        <LoadingAnimation
            :visible="(sendingRequest && showLoadingAnimation) || globalLoading"
            :full-page-loader="globalLoading"
        ></LoadingAnimation>
    </form>
</template>
<script>
import DuplicateOrderModal from './Order/DuplicateOrderModal.vue';
import debounce from 'lodash/debounce';
import LicensePlateInput from './LicensePlateInput.vue';
import NoticePopup from './Order/NoticePopup.vue';
import PaymentMethods from './PaymentMethods.vue';
import ServiceFeeInfo from './Order/ServiceFeeInfo.vue';
import ShopLimitValidityModal from './Shop/LimitValidityModal.vue';
import ShopStatePopup from './Order/ShopStatePopup.vue';
import TollProductCard from './TollProductCard.vue';
import Tooltip from './Layout/Tooltip.vue';
import UnsubscribeNewsletterModal from './Shop/UnsubscribeNewsletterModal.vue';
import VignetteProductCard from './VignetteProductCard.vue';
import LoadingAnimation from './LoadingAnimation.vue';
import IconTextContainer from './Layout/IconTextContainer.vue';
import DatePicker from './DatePicker.vue';

export default {
    components: {
        DuplicateOrderModal,
        LicensePlateInput,
        NoticePopup,
        DatePicker,
        PaymentMethods,
        ServiceFeeInfo,
        ShopLimitValidityModal,
        ShopStatePopup,
        TollProductCard,
        Tooltip,
        UnsubscribeNewsletterModal,
        VignetteProductCard,
        LoadingAnimation,
        IconTextContainer,
    },
    props: [
        'initialSettings',
        'defaultSelectedProduct',
        'defaultSelectedOption',
        'defaultSelectedRides',
        'defaultValidTo',
        'routeTollProduct',
        'products',
        'datepickerConfig',
        'licensePlateTemplates',
        'countryCodePhones',
        'tollProducts',
        'tollProductsStartPrice',
        'tollOptions',
        'currentDate',
        'orderPrice',
        'selectedCountryDefault',
        'serviceFee',
        'insuranceFee',
        'preFillFromSession',
        'defaultRightOfWithdrawal',
        'forceAutoScrollOnProductSelection',
        'autoScrollUpToWidth',
        'emRedirect',
        'emAbo',
        'systemId',
        'sessionVoucher',
        'shopTimezoneUtcOffset',
    ],
    data() {
        const defaultSettings = {};
        for (const key in this.initialSettings) {
            defaultSettings[key] = this.initialSettings[key];
        }

        return {
            defaultSettings,
            settings: this.initialSettings,
            limitValidityRangeForm: {
                triggered: false,
                placeholders: {},
                property: null,
            },
            showPackageChange: false,
            initialScroll: true,
            triggeredOptionFetch: false,
            initialTypesLoad: true,
            scrollToProduct: false,
            showSelectedValidityStartError: false,
            selectedInvoicePerPost: false,
            fullPageLoader: false,
            selectedWhatsApp: false,
            residenceInAustria: false,
            globalLoading: false,
            globalLoadingTimeout: 3000,
            selectedPhoneCode: 'false',
            phoneNumber: '',
            customer_outside_austria: null,
            datePickerOptions: this.$datePickerOptions,
            minDateDaysAdded: false,
            rightOfWithdrawal: this.defaultRightOfWithdrawal !== null ? '' + this.defaultRightOfWithdrawal : null,
            rightOfWithdrawalClass: {
                'btn-outline-primary': true,
                'btn-primary': false,
            },
            noRightOfWithdrawalClass: {
                'btn-outline-primary': true,
                'btn-primary': false,
            },
            paymentMethodSelectionAvailable: true,
            paymentMethod: null,
            selectedProduct: 0,
            selectedProductType: '',
            selectedProductUrlName: '',
            selectedProductUrlNames: {},
            selectedCountry: false,
            licensePlate: '',
            licensePlateConfirm: '',
            licensePlateValid: true,
            invoiceWanted: false,
            selectedRoute: 0,
            selectedTollOption: 0,
            availableTollOptions: [],
            sendingRequest: false,
            showLoadingAnimation: true,
            tosAccepted: false,
            asfinAccepted: false,
            licenseRevocationAccepted: false,
            receiveNewsletter: false,
            paymentSubscription: false,
            tosError: false,
            asfinError: false,
            licenseRevocationError: false,
            loadingPayPal: false,
            loadingKlarna: false,
            buyNowVisible: false,
            orderInsurance: false,
            vignetteValidFrom: this.initialSettings['shop.setDateValidFromToNull'] ? null : this.currentDate,
            routeTollValidityStart: this.currentDate,
            routeTollValidityEnd: '',
            vignetteValidTo: false,
            vignetteOptions: [],
            sortedVignetteOptions: [],
            selectedVignetteOption: null,
            formErrors: {},
            inputKeysChangeStatus: {
                email: false,
                product_id: false,
                option_id: false,
                valid_from: false,
                validity_start: false,
                country_code: false,
                license: false,
                first_name: false,
                last_name: false,
                street: false,
                house: false,
                postcode: false,
                city: false,
                special_license_plate_confirmed: true,
            },
            orderValidationCallback: null,
            isReadingFromSession: false,
            sessionMapping: {
                license_plate: 'licensePlate',
                license_plate_confirm: 'licensePlateConfirm',
                phone: 'phoneNumber',
                invoice_wanted: 'invoiceWanted',
            },
            loading: false,
            voucher: null,
            voucherError: '',
            duplicateOrders: [],
            customerMail: '',
            vignetteValidFromNotice: null,
            routeTollValidityStartNotice: null,
            licensePlateCheckStatus: false,
            licensePlateShowError: false,
            timeoutLicensePlateInvalidId: 0,
            setVignetteValidFromNullSetting: this.initialSettings['shop.setDateValidFromToNull'],
            isSpecialLicense: false,
        };
    },
    computed: {
        /**
         * Determine if used platform is mobile
         *
         * @returns {boolean}
         */
        isMobile() {
            return (
                /(android|webos|iphone|ipad|ipod|blackberry|windows phone)/.test(navigator.platform.toLowerCase()) ||
                window.matchMedia('only screen and (max-width: 767px)').matches
            );
        },
        /**
         * @returns {boolean}
         */
        showShopServiceFeePopup() {
            return (
                typeof this.settings['shop.showServiceFeePopup'] === 'boolean' &&
                this.settings['shop.showServiceFeePopup']
            );
        },
        /**
         * @returns {boolean}
         */
        detailedPriceDisplay() {
            return (
                typeof this.settings['shop.detailed_price_overview'] === 'boolean' &&
                this.settings['shop.detailed_price_overview']
            );
        },
        /**
         * @returns {boolean}
         */
        showLicenseRevocationCheckbox() {
            const showWithCountry = this.licensePlateTemplates.some(
                (template) =>
                    template.country_code === this.selectedCountry && template.show_license_revocation_checkbox
            );
            return this.settings['shop.enableLicenseRevocationCheckbox'] || showWithCountry;
        },
        /**
         * @returns {boolean}
         */
        showNewsletterCheckbox() {
            return this.settings['shop.enableNewsletterCheckbox'];
        },
        /**
         * @returns {boolean}
         */
        licensePlateCheckInvalid() {
            return (
                this.licensePlate.trim().length > 0 &&
                this.licensePlateConfirm.trim().length > 0 &&
                (this.licensePlate.localeCompare(this.licensePlateConfirm) !== 0 || !this.licensePlateCheckStatus)
            );
        },
        /**
         * @returns {boolean}
         */
        expiryOfRightOfWithdrawalActive() {
            return this.settings['shop.enableExpiryOfRightOfWithdrawal'];
        },
        /**
         * @returns {boolean}
         */
        showExpiryOfRightOfWithdrawal() {
            if (this.expiryOfRightOfWithdrawalActive) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.customer_outside_austria = !(this.residenceInAustria || this.selectedCountry == 'AT');
            }

            return this.expiryOfRightOfWithdrawalActive && !(this.residenceInAustria || this.selectedCountry == 'AT');
        },
        /**
         * @returns {boolean}
         */
        licenseRevocationAcceptedValid() {
            return (
                (this.showLicenseRevocationCheckbox && this.licenseRevocationAccepted) ||
                !this.showLicenseRevocationCheckbox
            );
        },
        /**
         * @returns {boolean}
         */
        whatsAppServiceActive() {
            return typeof this.settings['whatsapp.active'] === 'boolean' && this.settings['whatsapp.active'];
        },
        /**
         * @returns {boolean}
         */
        disableRightOfWithdrawalCompany() {
            return (
                typeof this.settings['registration.instant.disable'] === 'boolean' &&
                this.settings['registration.instant.disable']
            );
        },
        /**
         * @returns {boolean}
         */
        disableRightOfWithdrawal() {
            return (
                typeof this.settings['registration.delayed.disable'] === 'boolean' &&
                this.settings['registration.delayed.disable']
            );
        },
        /**
         * @returns {boolean}
         */
        invoicePostActive() {
            return typeof this.settings['invoice_post.active'] === 'boolean' && this.settings['invoice_post.active'];
        },
        /**
         * @returns {boolean}
         */
        missingLicensePlateTooltipActive() {
            return (
                typeof this.settings['shop.missing_license_plate_info_active'] === 'boolean' &&
                this.settings['shop.missing_license_plate_info_active']
            );
        },
        /**
         * @returns {number}
         */
        whatsAppServicePrice() {
            return this.settings['whatsapp.price'];
        },
        /**
         * @returns {number}
         */
        invoicePostPrice() {
            return this.settings['invoice_post.price'];
        },
        /**
         * @returns {number}
         */
        insuranceTimeout() {
            return this.settings['orderInsurance.cancelableBeforeSetup'];
        },
        /**
         * @returns {boolean}
         */
        showRouteTollCard() {
            return (
                typeof this.settings['homepage.displayRouteToll'] === 'boolean' &&
                this.settings['homepage.displayRouteToll']
            );
        },
        /**
         * @returns {boolean}
         */
        productUsesValidityRangePicker() {
            return this.products[this.selectedProduct]?.use_limit_validity_range_setting;
        },
        /**
         * @returns {boolean}
         */
        limitValidityStart() {
            return (
                typeof this.settings['shop.limitValidityRangePicker'] === 'number' &&
                this.settings['shop.limitValidityRangePicker'] > 0 &&
                this.productUsesValidityRangePicker
            );
        },
        /**
         * @returns {number}
         */
        limitValidityRangePicker() {
            return this.limitValidityStart ? this.settings['shop.limitValidityRangePicker'] : 0;
        },
        /**
         * @returns {boolean}
         */
        showPriceInProductCard() {
            return (
                typeof this.settings['homepage.showProductsPrices'] === 'boolean' &&
                this.settings['homepage.showProductsPrices']
            );
        },
        /**
         * Determine if the product/option allow the ordering as subscription.
         *
         * @returns {boolean}
         */
        isSubscriptionEnabled() {
            switch (this.selectedProductType) {
                case 'route_toll':
                    return (
                        typeof this.availableTollOptions[this.selectedTollOption] === 'object' &&
                        this.availableTollOptions[this.selectedTollOption] !== null &&
                        typeof this.availableTollOptions[this.selectedTollOption].enable_subscription === 'boolean' &&
                        this.availableTollOptions[this.selectedTollOption].enable_subscription
                    );

                default:
                    return (
                        this.selectedShopProduct !== null &&
                        typeof this.selectedShopProduct.enable_subscription === 'boolean' &&
                        this.selectedShopProduct.enable_subscription
                    );
            }
        },

        currentOrderValue: {
            get() {
                return this.getOrderPrice(null);
            },
        },

        buyNowAvailable() {
            return (
                this.tosAccepted &&
                !this.sendingRequest &&
                this.paymentMethod !== null &&
                this.licenseRevocationAcceptedValid
            );
        },

        countOfAvailableRegisterOptions() {
            let count = 0;

            if (typeof this.disableRightOfWithdrawal !== 'boolean' || !this.disableRightOfWithdrawal) {
                count++;
            }

            if (typeof this.disableRightOfWithdrawalCompany !== 'boolean' || !this.disableRightOfWithdrawalCompany) {
                count++;
            }

            return count;
        },

        customerReceiveNewsletter() {
            return this.receiveNewsletter;
        },

        getLastInsuranceDate() {
            if (!this.vignetteValidFrom) {
                return null;
            }

            const date = this.getFormattedDate(this.vignetteValidFrom);
            date.setMinutes(date.getMinutes() - this.insuranceTimeout);

            return (
                date.toLocaleDateString('de-DE').toString() +
                ', ' +
                date.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' }).toString()
            );
        },

        getInsuranceFee() {
            if (!this.insuranceFee) {
                return;
            }

            return this.insuranceFee.toFixed(2).toString() + ' €';
        },

        showOrderInsurance() {
            const showInsurance =
                this.vignetteValidFrom &&
                this.selectedShopProduct !== null &&
                this.selectedProductType === 'vignette' &&
                this.selectedVignetteOption &&
                this.vignetteOptions[this.selectedVignetteOption] &&
                this.vignetteOptions[this.selectedVignetteOption].insurance_fee &&
                !this.selectedShopProduct.insurance_included &&
                !this.isToday(this.getFormattedDate(this.vignetteValidFrom)) &&
                this.dateIsValidForOrderInsurance(this.getFormattedDate(this.vignetteValidFrom));

            // Reset order insurance value in any case when we hide it.
            if (!showInsurance) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.orderInsurance = false;
            }

            return showInsurance;
        },

        showInsuranceInfo() {
            let inProductIncluded = false;
            if (this.selectedProductType === 'vignette' && this.selectedShopProduct !== null) {
                inProductIncluded = this.selectedShopProduct.insurance_included;
            } else if (
                this.selectedProductType === 'route_toll' &&
                this.availableTollOptions !== null &&
                this.selectedTollOption !== null &&
                this.availableTollOptions[this.selectedTollOption] !== undefined
            ) {
                inProductIncluded = this.availableTollOptions[this.selectedTollOption].insurance_included;
            }

            return inProductIncluded && !this.showOrderInsurance;
        },

        selectedShopProduct() {
            switch (this.selectedProductType) {
                case 'vignette':
                    return this.products[this.selectedProduct] || null;

                case 'route_toll':
                    return this.tollProducts[this.selectedProduct] || null;

                default:
                    return null;
            }
        },

        selectedLicensePlateTemplates() {
            return this.licensePlateTemplates.filter(
                (templateOption) => this.selectedCountry && this.selectedCountry === templateOption.country_code
            );
        },

        sortedLicensePlateTemplates() {
            return [...this.licensePlateTemplates].sort((plate1, plate2) => {
                const countryA = this.$t('country.' + plate1.country_code).toLowerCase();
                const countryB = this.$t('country.' + plate2.country_code).toLowerCase();

                return countryA.localeCompare(countryB);
            });
        },

        selectedCountryCodePhones() {
            return this.countryCodePhones.filter(
                (templateOption) => templateOption.phone_code === this.selectedPhoneCode
            );
        },

        voucherDiscount() {
            if (this.voucher === null) return 0;

            switch (this.voucher.type) {
                case 'fixed':
                    return this.voucher.amount;
                case 'percentage':
                    return (this.serviceFee * this.voucher.amount) / 100;
            }

            return 0;
        },

        visibleProducts() {
            return Object.values(this.products)
                .filter(
                    (product) =>
                        !product.is_hidden ||
                        this.selectedProduct === product.id ||
                        (this.selectedProduct === 0 && this.defaultSelectedProduct.id === product.id)
                )
                .sort((a, b) => a.product_sort - b.product_sort);
        },

        routeTollValidityStartDisable() {
            return Object.keys(this.availableTollOptions).length > 0 && this.selectedTollOption > 0;
        },

        getOrderTimezone: {
            get() {
                return this.getBrowserTimezone();
            },
        },

        noticePopupText() {
            if (this.selectedShopProduct != null && this.selectedShopProduct.unavailable_notice) {
                return this.selectedShopProduct.unavailable_notice;
            } else {
                return '';
            }
        },
    },
    created: function () {
        this.debouncedValidateInput = debounce(this.validateInput, 2000);
    },
    beforeMount() {
        this.prefillFormFromSession();
    },
    mounted() {
        this.selectedCountry = this.selectedCountryDefault;
        setTimeout(this.selectInvoiceCountry, 10);
        setTimeout(this.selectPhoneCountry, 10);

        this.selectedRoute = this.defaultSelectedOption;
        this.availableTollOptions = (this.tollProducts[this.selectedRoute] || {}).options_keyed || [];
        let rideId = this.defaultSelectedRides;
        let rideOptionId = 0;

        if (this.selectedRoute > 0) {
            this.displayRouteOptions(rideId > 0);
            this.inputChange('product_id');
            this.saveToSession('toll_product', 'string', this.selectedRoute);
        }

        if (
            typeof this.availableTollOptions === 'object' &&
            Object.keys(this.availableTollOptions).length &&
            typeof this.availableTollOptions[rideId] === 'undefined'
        ) {
            const selector = rideId === 1 ? 'onetrip' : 'twotrips';

            Object.keys(this.availableTollOptions).forEach((optionId) => {
                if (this.availableTollOptions[optionId].selector === selector) {
                    rideId = optionId;
                    rideOptionId = optionId;

                    return false;
                }
            });
        }

        this.selectedTollOption = rideOptionId;

        if (this.selectedTollOption > 0) {
            this.displayRouteTollValidityRange();
            this.inputChange('option_id');
            this.saveToSession('option_id', 'string', this.selectedTollOption);
            this.$emit('price-change', (this.availableTollOptions[this.selectedTollOption] || {}).price || 0);
            this.$emit(
                'service-fee-change',
                (this.availableTollOptions[this.selectedTollOption] || {}).service_fee || 0
            );
            this.$emit('insurance-fee-change', 0);
        }

        if (this.currentDate && this.currentDate.trim() !== '') {
            const dateParts = this.currentDate.split('.');
            let date = new Date(Number(+dateParts[2]) + 1, dateParts[1] - 1, +dateParts[0]);
            date = date.setDate(date.getDate() - 1);

            const da = new Intl.DateTimeFormat('de', { day: '2-digit' }).format(date);
            const mo = new Intl.DateTimeFormat('de', { month: '2-digit' }).format(date);
            const ye = new Intl.DateTimeFormat('de', { year: 'numeric' }).format(date);

            this.routeTollValidityEnd = (da + '.' + mo + '.' + ye).toString();
        }

        document.addEventListener('DOMContentLoaded', () => {
            this.initToolTip();
        });

        this.showPackageChange = !this.isMobile;

        // If session has a voucher, call submitVoucherForm to apply it automatically.
        if (this.sessionVoucher) {
            setTimeout(() => {
                this.submitVoucherForm();
            }, 100);
        }
    },

    watch: {
        /**
         * Watches the selected vignette valid from, to check the order able limit.
         * If via setting and validity is controllable: the date will be set to null, when initialized.
         *
         * @returns {void}
         */
        vignetteValidFrom() {
            if (this.setVignetteValidFromNullSetting && this.products[this.selectedProduct].is_validity_controllable) {
                this.vignetteValidFrom = null;
                this.vignetteValidTo = false;
            }
            this.formErrors.validity_start = null;

            this.checkValidityRange(this.vignetteValidFrom, 'vignetteValidFrom');
        },

        /**
         * Watches the selected route-toll valid from, to check the order able limit.
         *
         * @returns {void}
         */
        routeTollValidityStart() {
            if (
                this.setVignetteValidFromNullSetting &&
                this.availableTollOptions[this.selectedTollOption].is_validity_controllable
            ) {
                this.routeTollValidityStart = null;
                this.vignetteValidTo = false;
            }
            this.formErrors.validity_start = null;

            this.checkValidityRange(this.routeTollValidityStart, 'routeTollValidityStart');
        },

        /**
         * Watches the live license plate inputs. If wrong, it triggers a timer to display error.
         *
         * @returns {void}
         */
        licensePlateCheckInvalid() {
            if (this.licensePlateCheckInvalid === true) {
                this.setDisplayLicensePlateErrorTimer();
            } else {
                this.licensePlateShowError = false;
            }
        },

        /**
         * Watches the live license plate inputs. If wrong, it triggers a timer to display error.
         *
         * @returns {void}
         */
        licensePlateConfirm() {
            this.setDisplayLicensePlateErrorTimer();
        },

        routeTollValidityStartDisable() {
            if (
                this.setVignetteValidFromNullSetting &&
                this.availableTollOptions[this.selectedTollOption].is_validity_controllable
            ) {
                this.routeTollValidityStart = null;
                this.vignetteValidTo = false;
            }
        },

        selectedShopProduct() {
            if (this.selectedShopProduct.is_unavailable) {
                this.$refs.noticePopup.showModal();
            }
        },
        isSpecialLicense(isSpecial) {
            if (isSpecial) {
                this.licensePlateShowError = false;
            }
        },
    },

    methods: {
        redirectHome() {
            window.location.replace('/');
        },

        /**
         * Handles the update of the order form settings depending on the selected option.
         *
         * @param {string} type
         *
         * @returns {void}
         */
        updateOrderFormSettings(type) {
            // Clone the default settings to assure, we can always handle a rollback to the initial provided
            // settings. Because not every option will override a setting.
            const settings = {};

            for (const settingKey in this.defaultSettings) {
                settings[settingKey] = this.defaultSettings[settingKey];
            }

            switch (type) {
                case 'vignette':
                    if (
                        typeof this.vignetteOptions[this.selectedVignetteOption].overrideSettings !== 'object' ||
                        this.vignetteOptions[this.selectedVignetteOption].overrideSettings === null ||
                        this.vignetteOptions[this.selectedVignetteOption].overrideSettings instanceof Array
                    ) {
                        break;
                    }

                    for (const key in this.vignetteOptions[this.selectedVignetteOption].overrideSettings) {
                        settings[key] = this.vignetteOptions[this.selectedVignetteOption].overrideSettings[key];
                    }
                    break;

                case 'route_toll':
                    if (
                        typeof this.availableTollOptions[this.selectedTollOption].overrideSettings !== 'object' ||
                        this.availableTollOptions[this.selectedTollOption].overrideSettings === null ||
                        this.availableTollOptions[this.selectedTollOption].overrideSettings instanceof Array
                    ) {
                        break;
                    }

                    for (const key in this.availableTollOptions[this.selectedTollOption].overrideSettings) {
                        settings[key] = this.availableTollOptions[this.selectedTollOption].overrideSettings[key];
                    }
                    break;

                default:
                    break;
            }

            this.settings = settings;
        },
        /**
         * Handle the product helper modal.
         *
         * @returns {void}
         */
        showUnsubscribeNewsletterModal() {
            this.$refs.unsubscribeNewsletterModal.showModal();
        },
        /**
         * Check the selected validity start date with the given min date.
         *
         * @param {string} date
         *
         * @returns {void}
         */
        checkSelectedValidityDate(date) {
            this.showSelectedValidityStartError = false;

            if (!this.datepickerConfig.minDate) {
                return;
            }

            // If the input is empty anyway, we can leave it with an error.
            if (date === '') {
                this.showSelectedValidityStartError = true;
                return;
            }

            const minDate = new Date(this.datepickerConfig.minDate);

            const validityStart = this.getFormattedDate(date);

            // Assure to check only the dates, which means we have to reset every time information.
            minDate.setHours(0);
            minDate.setMinutes(0);
            minDate.setSeconds(0);
            minDate.setMilliseconds(0);
            validityStart.setHours(0);
            validityStart.setMinutes(0);
            validityStart.setSeconds(0);
            validityStart.setMilliseconds(0);

            const diffTime = Math.abs(minDate - validityStart);
            const check = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

            // If the result is not positive, we should leave it with an error.
            if (Math.sign(check) < 0) {
                this.showSelectedValidityStartError = true;
            }
        },
        /**
         * Handle the check of the validity range to show a optional modal to register for a reminder.
         *
         * @param {string} date
         * @param {string} property
         *
         * @returns {void}
         */
        checkValidityRange(date, property) {
            // In the case we do not have a limit of order able days, we are fine with it to ignore the further
            // steps. Because these are only necessary if we want to limit up to a specific date.
            if (!this.limitValidityStart) {
                return;
            }

            // Ignore the validity range limit for pre order products.
            if (typeof this.selectedShopProduct.is_preorder === 'boolean' && this.selectedShopProduct.is_preorder) {
                return;
            }

            // Convert the provided date into a javascript date to check the limit.
            const validityStart = this.getFormattedDate(date);
            const today = new Date();

            // Assure to check only the dates, which means we have to reset every time information.
            validityStart.setHours(0);
            validityStart.setMinutes(0);
            validityStart.setSeconds(0);
            validityStart.setMilliseconds(0);
            today.setHours(0);
            today.setMinutes(0);
            today.setSeconds(0);
            today.setMilliseconds(0);

            const diffTime = Math.abs(validityStart - today);
            const check = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

            // Format the validity start date to display at securely at the info text.
            const vDa = new Intl.DateTimeFormat('de', { day: '2-digit' }).format(validityStart);
            const vMo = new Intl.DateTimeFormat('de', { month: '2-digit' }).format(validityStart);
            const vYe = new Intl.DateTimeFormat('de', { year: 'numeric' }).format(validityStart);

            // Set the data to handle the display of the modal.
            this.limitValidityRangeForm.placeholders.wishedDate = (vDa + '.' + vMo + '.' + vYe).toString();
            this.limitValidityRangeForm.placeholders.orderAbleAtDate = '';
            this.limitValidityRangeForm.property = property;

            // If the check value is equal or below the limit, we are fine to let the customer complete the process.
            if (check <= this.limitValidityRangePicker) {
                this.limitValidityRangeForm.triggered = false;

                return;
            }

            // Determine the date, when the product is able to be purchased.
            const purchasePossibleAt = new Date();
            purchasePossibleAt.setTime(validityStart.getTime() - this.limitValidityRangePicker * (3600 * 24 * 1000));
            const pDa = new Intl.DateTimeFormat('de', { day: '2-digit' }).format(purchasePossibleAt);
            const pMo = new Intl.DateTimeFormat('de', { month: '2-digit' }).format(purchasePossibleAt);
            const pYe = new Intl.DateTimeFormat('de', { year: 'numeric' }).format(purchasePossibleAt);

            this.limitValidityRangeForm.placeholders.orderAbleAtDate = (pDa + '.' + pMo + '.' + pYe).toString();
            this.limitValidityRangeForm.triggered = true;
            this.$nextTick(() => {
                this.$refs.shopLimitValidityModal.showModal();
            });
        },

        /**
         * Handle the declined callback of the validity limit modal.
         *
         * @param {object} $event
         *
         * @returns {void}
         */
        onValidityRangeDeclinedCallback($event) {
            switch (this.limitValidityRangeForm.property) {
                case 'vignetteValidFrom':
                    this.vignetteValidFrom = $event.purchaseAbleDate;
                    this.vignetteValidFromNotice = this.$t('shop.limitValidityRangeNotice', $event);
                    this.$refs.vignetteValidFrom.flatpickr.setDate($event.jsDate, true);
                    this.$refs.vignetteValidFrom.$el.scrollIntoView({ block: 'center', inline: 'center' });
                    break;

                case 'routeTollValidityStart':
                    this.routeTollValidityStart = $event.purchaseAbleDate;
                    this.routeTollValidityStartNotice = this.$t('shop.limitValidityRangeNotice', $event);
                    this.$refs.validityStart.flatpickr.setDate($event.jsDate, true);
                    this.$refs.validityStart.$el.scrollIntoView({ block: 'center', inline: 'center' });
                    break;
            }
        },

        getFormattedDate(date) {
            const dateParts = date.split(' ')[0].split('.');
            return new Date(Number(+dateParts[2]), dateParts[1] - 1, +dateParts[0]);
        },

        showInvalidValidityStartMessage($event) {
            this.vignetteValidFromNotice = this.$t('shop.selectedInvalidDateNotice', $event);
        },

        isToday(date) {
            const today = new Date();

            return (
                today.getFullYear() === date.getFullYear() &&
                today.getMonth() === date.getMonth() &&
                today.getDate() === date.getDate()
            );
        },

        dateIsValidForOrderInsurance(valDate) {
            const today = new Date();

            const diffTime = Math.abs(valDate - today);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

            if (diffDays === 1) {
                const thirtyMinInMilliseconds = 60 * 60 * 1000;
                const range = new Date(Date.now() + thirtyMinInMilliseconds);

                return (
                    today.getFullYear() === range.getFullYear() &&
                    today.getMonth() === range.getMonth() &&
                    today.getDate() === range.getDate()
                );
            }

            return true;
        },

        convertRemToPixels(rem) {
            return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
        },

        getScrollTop(ref) {
            const element = ref instanceof HTMLElement ? ref : document.querySelector(ref);
            const rect = element.getBoundingClientRect();
            const result = rect.top + window.pageYOffset - window.innerHeight / 2;

            return result < 0 ? result * -1 : result;
        },

        togglePackageChange() {
            this.showPackageChange = !this.showPackageChange;
        },

        splitDateTime(datetime) {
            let date = '',
                time = '',
                pos = -1;

            if (typeof datetime === 'string') {
                datetime = datetime.trim();
                pos = datetime.indexOf(' ');
                date = datetime;

                if (pos > 0) {
                    date = datetime.substr(0, pos);
                    time = datetime.substr(pos + 1);
                }
            }

            return {
                date: date,
                time: time,
            };
        },

        initToolTip() {
            if ('undefined' === typeof this.$refs.licensePlateTooltip) {
                return;
            }

            // already initiated
            if (this.$refs.licensePlateTooltip.classList.contains('registered')) {
                return;
            }

            $(this.$refs.licensePlateTooltip).popover();
            this.$refs.licensePlateTooltip.classList.add('registered');
        },

        getSelectedLicensePlateOption() {
            // has selected country and templates
            if (
                this.selectedCountry.length > 0 &&
                'object' === typeof this.licensePlateTemplates &&
                this.licensePlateTemplates instanceof Array &&
                this.licensePlateTemplates.length > 0
            ) {
                for (let i = 0; i < this.licensePlateTemplates.length; i++) {
                    if (this.selectedCountry === this.licensePlateTemplates[i].country_code) {
                        return this.licensePlateTemplates[i];
                    }
                }
            }
            return null;
        },

        parseLicensePlateInput(confirm) {
            // get the selected option
            const option = this.getSelectedLicensePlateOption();
            const canUpdate = null !== option && 'string' === typeof option.replace_whitespaces_with;
            let value = !confirm ? this.licensePlate : this.licensePlateConfirm;

            // has value and option found
            if (value.length && canUpdate) {
                // replace all whitespaces
                value = value.replace(/\s+/g, option.replace_whitespaces_with);
                // set the parsed value
                if (confirm) {
                    this.licensePlateConfirm = value;
                } else {
                    this.licensePlate = value;
                }
            }
        },

        getValueFromInput(name) {
            const input = document.querySelector('[name="' + name + '"]');

            return input === null ? null : input.value;
        },

        isPreFillActive() {
            return this.preFillFromSession;
        },

        clearFormSession() {
            // get the data from session
            const sessionKeys = Object.keys(window.sessionStorage);

            // step the keys
            for (let i = 0; i < sessionKeys.length; i++) {
                if (!sessionKeys[i].match(/orderForm\./)) {
                    continue;
                }
                window.sessionStorage.removeItem(sessionKeys[i]);
            }
        },

        prefillFormFromSession() {
            // no prefill active
            if (!this.isPreFillActive()) {
                return;
            }
            // set the flag, to prevent writing a second time
            this.isReadingFromSession = true;

            const alias = this;
            document.addEventListener('DOMContentLoaded', function () {
                // get the data from session
                const sessionKeys = Object.keys(window.sessionStorage);

                // has keys for load
                if (sessionKeys.length) {
                    // step only for selected product
                    for (let i = 0; i < sessionKeys.length; i++) {
                        // is type entry
                        if (sessionKeys[i].match(/orderForm\.(.+)\.type/)) {
                            continue;
                        }
                        // get the key
                        const key = alias.getSessionKey(sessionKeys[i]);
                        // not selected product or type
                        if ('selectedProduct' !== key && 'selectedProductType' !== key) {
                            continue;
                        }
                        // get the element
                        const value = alias.readFromSession(key, true),
                            elem = document.querySelector('[name="' + key + '"][value="' + value + '"]');

                        // is button and no submit
                        if (elem !== null && elem instanceof HTMLButtonElement && elem.type === 'button') {
                            elem.click();
                            break;
                        }
                    }

                    // wait for 10ms before prefill the whole form
                    setTimeout(function () {
                        // step the keys
                        for (let i = 0; i < sessionKeys.length; i++) {
                            // is type entry
                            if (sessionKeys[i].match(/orderForm\.(.+)\.type/)) {
                                continue;
                            } else if (
                                sessionKeys[i].match(/selectedProduct/) ||
                                sessionKeys[i].match(/selectedProductType/)
                            ) {
                                continue;
                            }

                            // get the data
                            let key = alias.getSessionKey(sessionKeys[i]),
                                value = alias.readFromSession(key, true),
                                elem = document.querySelector('[name="' + key + '"][value="' + value + '"]');

                            // value is undefined
                            if (value === undefined) {
                                continue;
                            }

                            // for key exists an session mapping
                            if ('string' === typeof alias.sessionMapping[key] && alias.sessionMapping[key].length) {
                                key = alias.sessionMapping[key];
                                if ('invoiceWanted' === key) {
                                    value = '1' === value;
                                }
                                // set the model
                                alias[key] = value;
                            } else if (
                                elem !== null &&
                                (elem instanceof HTMLButtonElement || elem instanceof HTMLInputElement) &&
                                ['button', 'radio', 'checkbox'].indexOf(elem.type) !== -1
                            ) {
                                elem.click();
                            } else {
                                setTimeout(function () {
                                    if (elem === null) {
                                        elem = document.querySelector('[name="' + key + '"]');
                                    }

                                    // check the type to prevent unwanted submit
                                    if (
                                        elem instanceof HTMLSelectElement ||
                                        elem instanceof HTMLTextAreaElement ||
                                        (elem instanceof HTMLInputElement &&
                                            ['submit', 'reset', 'radio', 'checkbox'].indexOf(elem.type) === -1)
                                    ) {
                                        elem.value = value;
                                        elem.dispatchEvent(new Event('change'));
                                    }
                                }, 10);
                            }
                        }

                        // remove flag
                        alias.isReadingFromSession = false;
                    }, 25);
                } else {
                    alias.isReadingFromSession = false;
                }
            });
        },

        getSessionKey(sessionName) {
            sessionName = sessionName.replace('orderForm.', '');
            if (sessionName.lastIndexOf('.') > 0) {
                sessionName = sessionName.substr(0, sessionName.lastIndexOf('.'));
            }
            return sessionName;
        },

        saveToSession(key, type, value) {
            // no prefill active
            if (!this.isPreFillActive()) {
                return;
            } else if (this.isReadingFromSession) {
                return;
            }

            // remove old entry
            this.removeFromSession(key);

            // is true or false => convert to numbers
            if (true === value) {
                value = 1;
            } else if (false === value) {
                value = 0;
            }

            window.sessionStorage.setItem('orderForm.' + key + '.type', type);
            window.sessionStorage.setItem('orderForm.' + key + '.value', '' + value);
        },

        removeFromSession(key) {
            window.sessionStorage.removeItem('orderForm.' + key + '.type');
            window.sessionStorage.removeItem('orderForm.' + key + '.value');
        },

        readFromSession(key, deleteFromSession) {
            let value = null;

            // keys exists
            if (
                window.sessionStorage.getItem('orderForm.' + key + '.type') &&
                window.sessionStorage.getItem('orderForm.' + key + '.value')
            ) {
                const type = window.sessionStorage.getItem('orderForm.' + key + '.type');
                value = window.sessionStorage.getItem('orderForm.' + key + '.value');

                if ('number' === type && 'number' !== typeof value) {
                    value = parseFloat(value);
                } else if ('bool' === type && 'boolean' !== typeof value) {
                    value = 'true' === value || 'false' === value || '0' === value || '1' === value;
                }

                if ('boolean' === typeof deleteFromSession && deleteFromSession) {
                    this.removeFromSession(key);
                }
            }

            return value;
        },

        getOrderPrice(digits, withDiscount = false) {
            let price = this.orderPrice;

            if (this.serviceFee > 0) {
                price += withDiscount ? Math.max(0, this.serviceFee - this.voucherDiscount) : this.serviceFee;
            }
            if (this.selectedWhatsApp && this.whatsAppServicePrice > 0) {
                price += this.whatsAppServicePrice;
            }
            if (this.selectedInvoicePerPost && this.invoicePostPrice > 0) {
                price += this.invoicePostPrice;
            }
            if (this.orderInsurance && this.insuranceFee > 0) {
                price += this.insuranceFee;
            }
            if ('number' === typeof digits && !isNaN(digits) && digits >= 0) {
                return price.toFixed(digits);
            }

            return price;
        },

        getIndexForVignetteOption(id) {
            id = '' + id;

            const ids = Object.keys(this.vignetteOptions);
            for (let i = 0; i < ids.length; i++) {
                if (ids[i] === id) {
                    return i;
                }
            }

            return -1;
        },

        getScrollTopOfElement(elem, headerHeightOffsetMultiplier) {
            if (typeof headerHeightOffsetMultiplier !== 'number' || isNaN(headerHeightOffsetMultiplier)) {
                headerHeightOffsetMultiplier = 1;
            }

            const elemHeight = (
                elem instanceof HTMLElement ? elem : document.querySelector(elem)
            ).getBoundingClientRect().height;
            const topNavHeight =
                document.querySelector('#topnav') !== null
                    ? document.querySelector('#topnav').getBoundingClientRect().height
                    : 0;

            return (
                this.getScrollTop(elem) +
                elemHeight * headerHeightOffsetMultiplier +
                topNavHeight * headerHeightOffsetMultiplier
            );
        },

        disableGlobalLoader() {
            this.globalLoading = false;
        },

        submitOrderForm() {
            // If the validity range form is triggered, we are not allowed to submit the order form. Because
            // the selected date is out of the expected range of order able products.
            if (this.limitValidityRangeForm.triggered) {
                return;
            }

            if (this.selectedShopProduct && this.selectedShopProduct.is_unavailable) {
                this.$refs.noticePopup.showModal();

                return;
            }

            this.licensePlateShowError = false;
            this.tosError = false;
            this.asfinError = false;
            this.licenseRevocationError = false;

            // accepted and payment method selected
            if (
                this.tosAccepted &&
                this.asfinAccepted &&
                null !== this.paymentMethod &&
                this.licenseRevocationAcceptedValid
            ) {
                // remove form errors
                this.formErrors = {};
                this.showLoadingAnimation = false;
                this.globalLoading = true;
                this.fullPageLoader = true;

                // create callback function
                this.orderValidationCallback = function (result) {
                    // remove the callback
                    this.orderValidationCallback = null;

                    // invalid form
                    if (!result.data.valid) {
                        this.globalLoading = false;
                        this.fullPageLoader = false;

                        this.formErrors = result.data.errors;

                        setTimeout(
                            function () {
                                let invalidFormField = null;
                                if (this.formErrors.validity_start && this.selectedProductType === 'route_toll') {
                                    invalidFormField = document.querySelectorAll('.invalid-feedback:not(:empty)')[1];
                                } else {
                                    invalidFormField = document.querySelector('.invalid-feedback:not(:empty)');
                                }

                                if (invalidFormField !== null) {
                                    const elementY = invalidFormField.parentElement.getBoundingClientRect().top - 50;
                                    const topNavHeight = document
                                        .querySelector('#topnav')
                                        .getBoundingClientRect().height;
                                    const windowY = window.scrollY;

                                    window.scrollTo(0, windowY + elementY - topNavHeight);
                                }
                            }.bind(this),
                            10
                        );

                        return;
                    }

                    // Check for duplicated order when vignette product selected
                    if (
                        this.selectedProductType === 'vignette' &&
                        result.data.duplicateOrder !== false &&
                        'object' === typeof result.data.duplicateOrder &&
                        result.status === 200 &&
                        result.data.valid &&
                        null !== this.paymentMethod
                    ) {
                        // Navigate to the url
                        this.forwardToCreatedOrder(result.data.duplicateOrder);
                    } else if (result.status === 200 && result.data.shopActive === false) {
                        // If the shop is inactive, stop here and show a modal.
                        this.changeSendingRequest(false);
                        this.showLoadingAnimation = false;
                        this.globalLoading = false;
                        this.fullPageLoader = false;

                        this.$refs.shopStatePopup.showModal();
                    } else if (
                        result.status === 200 &&
                        result.data.valid &&
                        this.tosAccepted &&
                        this.asfinAccepted &&
                        this.licenseRevocationAcceptedValid &&
                        null !== this.paymentMethod
                    ) {
                        // order form is valid for order
                        this.validateAndCreateOrder();
                    }
                };
                // validate the order
                this.inputChange(null, true);
            } else {
                if (!this.licenseRevocationAcceptedValid) {
                    this.licenseRevocationError = true;
                }
                if (!this.tosAccepted) {
                    this.tosError = true;
                }
                if (!this.asfinAccepted) {
                    this.asfinError = true;
                }

                const elementY = this.$refs.tosAcceptedContainer.getBoundingClientRect().top;
                const topNavHeight = document.querySelector('#topnav').getBoundingClientRect().height;
                const windowY = window.scrollY;

                window.scrollTo(0, windowY + elementY - topNavHeight);
            }
        },

        submitVoucherForm() {
            // If session has a voucher it will be applied when component loaded.
            const form = new FormData(this.$refs.voucherForm);
            if (this.sessionVoucher) {
                form.set('voucher_code', this.sessionVoucher);
                form.set('product_id', this.selectedProduct);
                form.set('product_type', this.selectedProductType);
            }
            if (!form.has('voucher_code') || form.get('voucher_code').length === 0 || this.voucher) {
                const checkoutButton = this.$refs.checkoutButton;
                if (checkoutButton) {
                    checkoutButton.scrollIntoView({ behavior: 'smooth', block: 'end' });
                }
                return;
            }

            this.loading = true;
            this.voucherError = '';

            axios
                .post('/' + this.$language + '/backend/validate/voucher', form)
                .then((response) => {
                    if (response.data.valid) {
                        this.voucher = response.data.voucher;
                    } else if (response.data.errors && response.data.errors.voucher_code) {
                        this.voucherError = response.data.errors.voucher_code[0];
                    } else {
                        throw new Error('Invalid voucher');
                    }
                })
                .catch(() => {
                    this.inputChange();
                    this.voucherError = this.$t('shop.voucher_invalid');
                })
                .then(() => {
                    // This one's always executed, acting like a finally-block for try-catch
                    this.loading = false;
                    this.$refs.voucherForm.reset();
                });
        },

        getDateByStrings(day, month, fullYear, hours, minutes, seconds) {
            const date = new Date();
            date.setDate(day);
            date.setMonth(month);
            date.setFullYear(fullYear);
            date.setHours(hours);
            date.setMinutes(minutes);
            date.setSeconds(seconds);
            date.setMilliseconds(0);
            return date;
        },

        getDatePickerMinDate() {
            let minDate = this.getSelectedOptionMinDate();

            if (!minDate) {
                if ('undefined' === typeof this.datePickerOptions.minDate) {
                    minDate = new Date();
                } else if (!(this.datePickerOptions.minDate instanceof Date)) {
                    minDate = new Date(this.datePickerOptions.minDate);
                } else {
                    minDate = new Date();
                    minDate.setDate(this.datePickerOptions.minDate.getDate());
                    minDate.setMonth(this.datePickerOptions.minDate.getMonth());
                    minDate.setFullYear(this.datePickerOptions.minDate.getFullYear());
                }
            }

            return minDate;
        },

        getDatePickerMaxDate() {
            if (
                this.datepickerConfig === undefined ||
                !this.datepickerConfig ||
                !this.datepickerConfig.maxDate ||
                !this.selectedShopProduct
            ) {
                return null;
            }

            const values = Object.values(this.selectedShopProduct.options);
            const maxDate = new Date(
                Math.max(
                    ...values.map((element) => {
                        if (this.selectedProductType === 'vignette') {
                            let vehicleType;

                            if (this.selectedVignetteOption) {
                                vehicleType = this.selectedShopProduct.options.find(
                                    (option) => option.id === this.selectedVignetteOption
                                )?.vehicle_type;

                                if (!vehicleType) {
                                    return this.selectedShopProduct.options[0].valid_until
                                        ? new Date(this.selectedShopProduct.options[0].valid_until)
                                        : 0;
                                }
                            } else {
                                vehicleType = this.selectedShopProduct.options[0].vehicle_type;
                            }

                            return element.valid_until && element.vehicle_type === vehicleType
                                ? new Date(element.valid_until)
                                : 0;
                        } else {
                            return element.valid_until &&
                                element.selector === this.availableTollOptions[this.selectedTollOption].selector
                                ? new Date(element.valid_until)
                                : 0;
                        }
                    })
                )
            );

            if (maxDate && maxDate instanceof Date && maxDate > new Date()) {
                return (
                    maxDate.getFullYear() +
                    '-' +
                    (maxDate.getMonth() + 1).toString().padStart(2, '0') +
                    '-' +
                    maxDate.getDate().toString().padStart(2, '0') +
                    'T00:00:00.000000Z'
                );
            }

            return this.datepickerConfig.maxDate;
        },

        updateDatePicker() {
            let backToEarliest = false;

            const minDate = this.getDatePickerMinDate(),
                maxDate = this.getDatePickerMaxDate();

            // right of withdrawal is active
            if ('true' === this.rightOfWithdrawal) {
                // add the dates
                if (!this.minDateDaysAdded) {
                    minDate.setDate(minDate.getDate() + 18);
                    this.minDateDaysAdded = true;
                }
                // switch classes
                this.rightOfWithdrawalClass['btn-outline-primary'] = false;
                this.rightOfWithdrawalClass['btn-primary'] = true;
                this.noRightOfWithdrawalClass['btn-outline-primary'] = true;
                this.noRightOfWithdrawalClass['btn-primary'] = false;
            } else if ('false' === this.rightOfWithdrawal) {
                // added the days
                if (this.minDateDaysAdded) {
                    minDate.setDate(minDate.getDate() - 18);
                    this.minDateDaysAdded = false;
                    backToEarliest = true;
                }

                // switch classes
                this.rightOfWithdrawalClass['btn-outline-primary'] = true;
                this.rightOfWithdrawalClass['btn-primary'] = false;
                this.noRightOfWithdrawalClass['btn-outline-primary'] = false;
                this.noRightOfWithdrawalClass['btn-primary'] = true;
            }

            this.setNewDatesForDatePicker(minDate, maxDate);

            // config for date change
            let property = null,
                currentValue = null,
                forceDateUpdate = false;

            // check the product type for valid date start
            if ('vignette' === this.selectedProductType) {
                property = 'vignetteValidFrom';
                currentValue =
                    'string' === typeof this.vignetteValidFrom && this.vignetteValidFrom.length
                        ? this.vignetteValidFrom
                        : null;
            } else if ('route_toll' === this.selectedProductType) {
                property = 'routeTollValidityStart';
                currentValue =
                    'string' === typeof this.routeTollValidityStart && this.routeTollValidityStart.length
                        ? this.routeTollValidityStart
                        : null;
            }

            // We should load the current selected product to check if the preorder mode
            // was enabled. If this condition is set, we have to check if an validity from and
            // validity until is defined.
            const transformDate = function (timestamp, withTime) {
                if (typeof timestamp !== 'object' || !(timestamp instanceof Date)) {
                    timestamp = new Date(timestamp);
                }

                const date = (timestamp.getDate() > 9 ? '' : '0') + timestamp.getDate();
                const month = (timestamp.getMonth() > 9 ? '' : '0') + timestamp.getMonth();
                const year = timestamp.getFullYear();
                let suffix = '';

                if (typeof withTime === 'boolean' && withTime) {
                    suffix = ' ';
                    suffix += (timestamp.getHours() > 9 ? '' : '0') + timestamp.getHours();
                    suffix += (timestamp.getMinutes() > 9 ? '' : '0') + timestamp.getMinutes();
                    suffix += (timestamp.getSeconds() > 9 ? '' : '0') + timestamp.getSeconds();
                }

                return `${date}.${month}.${year}${suffix}`;
            };

            if (
                this.selectedShopProduct !== null &&
                typeof this.selectedShopProduct.is_preorder === 'boolean' &&
                this.selectedShopProduct.is_preorder &&
                typeof this.selectedShopProduct.preorder_validity_from === 'string' &&
                typeof this.selectedShopProduct.preorder_validity_until === 'string' &&
                this.selectedShopProduct.preorder_validity_from.length &&
                this.selectedShopProduct.preorder_validity_until.length
            ) {
                this.datePickerOptions.minDate = new Date(this.selectedShopProduct.preorder_validity_from);
                this[property] = transformDate(this.selectedShopProduct.preorder_validity_from);
                forceDateUpdate = true;
            } else if (
                this.selectedShopProduct !== null &&
                typeof this.selectedShopProduct.is_validity_controllable !== 'undefined' &&
                [0, false].indexOf(this.selectedShopProduct.is_validity_controllable) !== -1 &&
                typeof this.selectedShopProduct.runtimeMinDate === 'string'
            ) {
                this.datePickerOptions.minDate = new Date(this.selectedShopProduct.runtimeMinDate);
                this[property] = transformDate(this.selectedShopProduct.runtimeMinDate);
                forceDateUpdate = true;
            }

            // has current value parse to date
            if (null !== currentValue && 'string' === typeof currentValue) {
                currentValue = currentValue.split('.');
                currentValue = new Date(currentValue[2] + '-' + currentValue[1] + '-' + currentValue[0] + 'T00:00:00Z');
            }

            const dpOptionsMinDate = new Date(this.datePickerOptions.minDate);

            if (forceDateUpdate || null === currentValue || backToEarliest || currentValue < dpOptionsMinDate) {
                const year = dpOptionsMinDate.getFullYear(),
                    month = dpOptionsMinDate.getMonth() + 1,
                    day = dpOptionsMinDate.getDate();

                this[property] = (day > 9 ? '' : '0') + day + '.' + (month > 9 ? '' : '0') + month + '.' + year;

                if ('vignetteValidFrom' === property && 'undefined' !== typeof this.$refs.vignetteValidFrom) {
                    const alias = this;
                    setTimeout(function () {
                        const tmp = alias.getDateByStrings(day, month - 1, year, 0, 0, 0);
                        if ('undefined' !== typeof alias.$refs.vignetteValidFrom.dp) {
                            alias.$refs.vignetteValidFrom.dp.date(tmp);
                        } else if ('undefined' !== typeof alias.$refs.vignetteValidFrom.flatpickr) {
                            alias.$refs.vignetteValidFrom.flatpickr.setDate(tmp, true);
                        }
                    }, 10);
                }
            }
        },

        setNewDatesForDatePicker(minDate, maxDate) {
            let minimumDate = minDate;

            if (this.vignetteValidFrom && this.vignetteValidFrom.trim() !== '') {
                const selectedDate = this.getFormattedDate(this.vignetteValidFrom);

                // Check if the date is valid and between the days
                if (selectedDate <= new Date(maxDate) && selectedDate >= new Date(minDate)) {
                    minimumDate =
                        selectedDate.getFullYear() +
                        '-' +
                        (selectedDate.getMonth() + 1).toString().padStart(2, '0') +
                        '-' +
                        selectedDate.getDate().toString().padStart(2, '0') +
                        'T00:00:00.000000Z';
                }
            }

            const prop = this.selectedProductType === 'vignette' ? 'vignetteValidFrom' : 'routeTollValidityStart';
            if (this.$refs[prop]) {
                this.$refs[prop].setDate(minimumDate);
                this.$refs[prop].setMinDate(minDate);
                this.$refs[prop].setMaxDate(maxDate);
            } else {
                this.datePickerOptions.minDate = minimumDate;
                this.datePickerOptions.maxDate = maxDate;
            }

            minimumDate = new Date(minimumDate);
            this.vignetteValidFrom =
                minimumDate.getDate().toString().padStart(2, '0') +
                '.' +
                (minimumDate.getMonth() + 1).toString().padStart(2, '0') +
                '.' +
                minimumDate.getFullYear();
        },

        getSelectedOptionMinDate() {
            // Return nothing, if fallback min date is not set.
            if (this.datepickerConfig === undefined || !this.datepickerConfig || !this.datepickerConfig.minDate) {
                return null;
            }

            const defaultMinDate = this.datepickerConfig.minDate;
            const productOption =
                this.selectedProductType === 'vignette' ? this.selectedVignetteOption : this.selectedTollOption;

            if (!productOption) {
                return this.getFirstOptionMinDate(defaultMinDate);
            }

            // Get the very first minDate of the selected option.
            // If no option is selected, we use the first option.
            // After we got the minDate, we will check, if the returned date is valid for our purpose.
            // Otherwise, we will return either the minDate of the datepicker config or a valid first option min date.
            const values = Object.values(this.selectedShopProduct.options);
            const minDate = new Date(
                Math.min(
                    ...values
                        .filter((element) => {
                            if (this.selectedProductType === 'vignette') {
                                let vehicleType;
                                if (this.selectedVignetteOption) {
                                    vehicleType = this.selectedShopProduct.options.find(
                                        (option) => option.id === this.selectedVignetteOption
                                    )?.vehicle_type;

                                    if (!vehicleType) {
                                        return this.selectedShopProduct.options[0].valid_until
                                            ? new Date(this.selectedShopProduct.options[0].valid_until)
                                            : 0;
                                    }
                                } else {
                                    vehicleType = this.selectedShopProduct.options[0].vehicle_type;
                                }
                                return element.valid_from && element.vehicle_type === vehicleType;
                            } else {
                                const selector = this.availableTollOptions[this.selectedTollOption].selector;
                                return element.valid_from && element.selector === selector;
                            }
                        })
                        .map((element) => {
                            return Math.floor(new Date(element.valid_from).getTime() / 1000);
                        })
                ) * 1000
            );

            if (!minDate || !(minDate instanceof Date) || new Date() > minDate) {
                return this.getFirstOptionMinDate(defaultMinDate);
            }

            return minDate;
        },

        getFirstOptionMinDate(defaultMinDate) {
            if (!this.selectedShopProduct) {
                return defaultMinDate;
            }

            const firstOptionMinDate = this.selectedShopProduct.options[0].valid_from;
            if (!firstOptionMinDate || new Date() > new Date(firstOptionMinDate)) {
                return defaultMinDate;
            }
            return firstOptionMinDate;
        },

        selectInvoiceCountry() {
            let id = null;
            // Reset licensePlate input when country is changed.
            this.licensePlate = '';
            this.licensePlateConfirm = '';

            // country is selected
            if ('string' === typeof this.selectedCountry && this.selectedCountry.length) {
                for (let i = 0; i < this.licensePlateTemplates.length; i++) {
                    if (this.selectedCountry === this.licensePlateTemplates[i].country_code) {
                        id = this.licensePlateTemplates[i].country_name;
                        break;
                    }
                }
            }

            // set the country
            const select = document.querySelector('#country');

            if (select !== null) {
                select.value = id;
            }
        },
        selectPhoneCountry() {
            let id = null;

            // country is selected
            if ('string' === typeof this.selectedCountry && this.selectedCountry.length) {
                for (let i = 0; i < this.countryCodePhones.length; i++) {
                    if (this.selectedCountry === this.countryCodePhones[i].country_code) {
                        id = this.countryCodePhones[i].phone_code;
                        break;
                    }
                }
            }

            // set the country
            this.selectedPhoneCode = id;

            const select = document.querySelector('#phone-code');

            if (select !== null) {
                select.value = id;
            }
        },

        getWindowOuterWidth() {
            return window.innerWidth;
        },

        prepareInitialDisplayOfVignetteOptions() {
            const options = {};

            if (this.defaultSelectedProduct.options <= 0) {
                return options;
            }

            this.defaultSelectedProduct.options.forEach((option) => {
                options[option.id] = option;
            });

            return options;
        },

        updateOrderFormWithLoadedOption(option) {
            if (
                null !== option &&
                (this.selectedVignetteOption === null ||
                    typeof this.vignetteOptions[this.selectedVignetteOption] === 'undefined')
            ) {
                this.selectedVignetteOption =
                    Object.values(this.vignetteOptions).find(
                        (option) =>
                            option.vehicle_type ===
                            this.selectedShopProduct.options.find(
                                (selectedOption) => selectedOption.id === this.selectedVignetteOption
                            )?.vehicle_type
                    )?.id ?? option.id;
                this.updateOrderFormSettings('vignette');
                this.inputChange('option_id');
                this.$emit('price-change', option.price);
                this.$emit('service-fee-change', option.service_fee);
                this.$emit('insurance-fee-change', option.insurance_fee);
            }
        },

        displayDefaultTypeOptions() {
            this.vignetteOptions = this.prepareInitialDisplayOfVignetteOptions();
            this.vignetteValidTo = this.defaultValidTo;
            this.sortVignetteOptions();
            this.updateOrderFormWithLoadedOption(this.getVignetteOptionByVehicleType());
        },

        sortVignetteOptions() {
            this.sortedVignetteOptions = Object.values(this.vignetteOptions);

            // Apply the sorting of the items.
            this.sortedVignetteOptions.sort(function (item1, item2) {
                // The sorting values are equal.
                if (item1.vehicle_type === item2.vehicle_type) {
                    return 0;
                }

                return item1.vehicle_type < item2.vehicle_type ? 1 : -1;
            });
        },

        getVignetteOptionByVehicleType(vehicleType = null) {
            const keys = Object.keys(this.vignetteOptions);
            let option = null;

            for (let i = 0; i < keys.length; i++) {
                const type = (this.vignetteOptions[keys[i]] || {}).vehicle_type || '';

                if ((vehicleType !== null && vehicleType === type) || ('car' === type && vehicleType === null)) {
                    option = this.vignetteOptions[keys[i]];
                    break;
                }
            }

            return option;
        },

        displayTypeOptions() {
            if (this.triggeredOptionFetch) {
                return;
            }

            this.triggeredOptionFetch = true;

            if (this.initialTypesLoad) {
                this.displayDefaultTypeOptions();

                this.initialTypesLoad = false;
                setTimeout(() => {
                    this.triggeredOptionFetch = false;
                }, 10);

                return;
            }

            this.vignetteValidTo = false;

            axios
                .get(
                    '/' +
                        this.$language +
                        '/backend/options/vignette/' +
                        this.selectedProduct +
                        (this.products[this.selectedProduct].is_validity_controllable && this.vignetteValidFrom
                            ? '?valid=' + this.vignetteValidFrom
                            : '')
                )
                .then((response) => {
                    this.vignetteOptions = response.data.options;
                    if (
                        !this.setVignetteValidFromNullSetting ||
                        !this.products[this.selectedProduct].is_validity_controllable
                    ) {
                        this.vignetteValidTo = response.data.runtime_end;
                    }

                    // Before sorting the vignette options, we need to find the previous vehicle type
                    // within the last vignette options, to get the new price properly updated.
                    const currentOptionVehicleType =
                        this.sortedVignetteOptions.find((option) => option.id === this.selectedVignetteOption)
                            .vehicle_type ?? null;
                    const option = this.getVignetteOptionByVehicleType(currentOptionVehicleType);
                    this.sortVignetteOptions();
                    setTimeout(this.disableGlobalLoader, this.globalLoadingTimeout);
                    this.updateOrderFormWithLoadedOption(option);
                })
                .finally(() => {
                    this.triggeredOptionFetch = false;
                });
        },
        async inputChange(inputKey, validateRequest) {
            if (typeof inputKey !== 'undefined') {
                if (
                    'option_id' === inputKey &&
                    this.availableTollOptions &&
                    this.selectedProductType === 'route_toll'
                ) {
                    // Show payment subscription by default if enabled
                    this.paymentSubscription =
                        typeof this.availableTollOptions[this.selectedTollOption] === 'object' &&
                        this.availableTollOptions[this.selectedTollOption] !== null &&
                        typeof this.availableTollOptions[this.selectedTollOption].subscription_by_default ===
                            'boolean' &&
                        this.availableTollOptions[this.selectedTollOption].subscription_by_default;
                }

                // is invoice per post switch
                if ('invoice_per_post' === inputKey && this.selectedInvoicePerPost) {
                    this.invoiceWanted = true;
                }

                // loading animation not visible yet
                if (!this.showLoadingAnimation) {
                    this.showLoadingAnimation = ['payment_method'].indexOf(inputKey) >= 0;
                }

                // country code got changed
                if ('country_code' === inputKey) {
                    if (
                        null === document.querySelector('#country') ||
                        null === document.querySelector('#country').value
                    ) {
                        this.selectInvoiceCountry();
                    }
                    setTimeout(this.selectPhoneCountry, 10);
                } else if ('invoice_wanted' === inputKey) {
                    setTimeout(this.selectInvoiceCountry, 10);
                }

                if (
                    'right_of_withdrawal' === inputKey &&
                    this.getWindowOuterWidth() <= this.autoScrollUpToWidth &&
                    document.querySelector('#product-form') !== null
                ) {
                    const elementY = document.querySelector('#product-form').getBoundingClientRect().top;
                    const topNavHeight = document.querySelector('#topnav').getBoundingClientRect().height;
                    const windowY = window.scrollY;

                    window.scrollTo(0, windowY + elementY - topNavHeight);
                }

                // Check if the selected date is empty and reset it.
                if ('validity_start' === inputKey && this.vignetteValidFrom === '' && this.datepickerConfig.minDate) {
                    const minDate = new Date(this.datepickerConfig.minDate);

                    // Reset the value of the input correctly.
                    document.querySelector('input.datepicker-input:not([type="hidden"])').value =
                        minDate.getFullYear() +
                        '-' +
                        (minDate.getMonth() + 1).toString().padStart(2, '0') +
                        '-' +
                        minDate.getDate().toString().padStart(2, '0');

                    // Reset the date
                    this.vignetteValidFrom = this.currentDate;
                }

                this.inputKeysChangeStatus[inputKey] = true;
            }

            if ('boolean' === typeof validateRequest && validateRequest) {
                this.changeSendingRequest(true);
                this.debouncedValidateInput();
            }
        },
        async validateInput() {
            const isValid = await axios
                .post('/' + this.$language + '/backend/validate/order', new FormData(this.$refs.orderForm))
                .then((result) => {
                    this.changeSendingRequest(false);
                    this.showLoadingAnimation = false;

                    // has callback => call it
                    if ('function' === typeof this.orderValidationCallback) {
                        this.orderValidationCallback(result);
                    } else if (!result.data.valid) {
                        for (var inputKey in result.data.errors) {
                            if (
                                typeof this.inputKeysChangeStatus[inputKey] === 'undefined' ||
                                !this.inputKeysChangeStatus[inputKey]
                            ) {
                                delete result.data.errors[inputKey];
                            }
                        }

                        this.formErrors = result.data.errors;
                    } else {
                        this.formErrors = {};
                    }

                    this.preselectRouteTollOption();

                    return result.status === 200 && result.data.valid;
                })
                .catch(() => {
                    this.changeSendingRequest(false);
                });

            this.buyNowVisible = isValid === true;
        },
        forwardToCreatedOrder(duplicateOrder) {
            // Check the given data
            if (duplicateOrder.foundOrder && 'string' === typeof duplicateOrder.orderUri) {
                // Navigate to uri
                try {
                    window.location.href = duplicateOrder.orderUri;
                } finally {
                    this.changeSendingRequest(false);
                    this.globalLoading = false;
                    this.fullPageLoader = false;
                }
            }
        },
        validateAndCreateOrder() {
            if (this.limitValidityRangeForm.triggered) {
                return;
            }

            this.changeSendingRequest(true);
            this.showLoadingAnimation = false;
            this.globalLoading = true;
            this.fullPageLoader = true;

            axios
                .post('/' + this.$language + '/payment', new FormData(this.$refs.orderForm))
                .then((response) => {
                    if (typeof response.data.duplicateOrders === 'object') {
                        this.duplicateOrders = response.data.duplicateOrders;
                        this.$refs.duplicateOrdersModal.onShowModal();
                        return;
                    }

                    // clear the form session
                    this.clearFormSession();

                    this.paymentMethodSelectionAvailable = false;
                    this.changeSendingRequest(false);
                    this.showLoadingAnimation = false;

                    if ('string' === typeof response.data.orderUri) {
                        window.location.href = response.data.orderUri;
                    }
                })
                .catch(() => {
                    this.inputChange();
                })
                .then(() => {
                    // This one's always executed, acting like a finally-block for try-catch
                    this.changeSendingRequest(false);
                    this.globalLoading = false;
                    this.fullPageLoader = false;
                });
        },
        displayRouteTollValidityRange() {
            axios
                .get(
                    '/' +
                        this.$language +
                        '/backend/validity/' +
                        this.selectedTollOption +
                        '?start=' +
                        this.routeTollValidityStart +
                        '&timestamp=' +
                        Date.now()
                )
                .then((response) => {
                    if (
                        !this.setVignetteValidFromNullSetting ||
                        !this.products[this.selectedProduct].is_validity_controllable
                    ) {
                        this.vignetteValidTo = response.data.runtime_end;
                    }
                });
        },

        resetRouteTollValidityIfNullable() {
            if (
                this.setVignetteValidFromNullSetting &&
                this.availableTollOptions[this.selectedTollOption].is_validity_controllable
            ) {
                this.routeTollValidityStart = null;
                this.vignetteValidTo = false;
            }
        },

        preselectRouteTollOption() {
            if ('route_toll' === this.selectedProductType && 0 === this.selectedProduct) {
                const firstOption = this.$refs.routeTollProduct.querySelector('option:not([disabled])');

                this.$refs.routeTollProduct.value = firstOption.value;
                this.$refs.routeTollProduct.dispatchEvent(new Event('change'));
            }
        },

        updateStructuredProductData() {
            const structuredDataStore = document.querySelector('#structured-product');

            if (structuredDataStore === null) {
                return;
            }

            let product = null;

            if (this.selectedProductType === 'vignette') {
                product = this.products[this.selectedProduct] || null;
            } else if (this.selectedProductType === 'route_toll') {
                product = this.tollProducts[this.selectedProduct] || null;
            }

            if (product === null || typeof product.metadata !== 'object') {
                structuredDataStore.innerText = '';
                return;
            }

            // Replace the description content if available at the product.
            const description = document.querySelector('#description');
            description.innerHTML = product.metadata.shopDescription || '';

            structuredDataStore.innerText = JSON.stringify(product.metadata.structuredData);
        },

        updateProductMetadata(prevUrlName, prevUrlNames) {
            let product = null;

            if (this.selectedProductType === 'vignette') {
                product = this.products[this.selectedProduct] || null;
            } else if (this.selectedProductType === 'route_toll') {
                product = this.tollProducts[this.selectedProduct] || null;
            }

            if (!product) {
                return;
            }

            let title = this.$t('meta.title');
            if (product.meta_title && product.meta_title.length > 0) {
                title = product.meta_title;
            }

            document.title = title;
            document.querySelector('meta[name="title"]').setAttribute('content', title);

            let description = this.$t('meta.description');
            if (product.meta_description && product.meta_description.length > 0) {
                description = product.meta_description;
            }

            document.querySelector('meta[name="description"]').setAttribute('content', description);

            if (prevUrlName && prevUrlNames) {
                const defaultLanguage = 'en';

                document.querySelectorAll('link[rel="canonical"]').forEach((link) => {
                    link.href = link.href.replace(prevUrlName, this.selectedProductUrlName);
                });

                document.querySelectorAll('link[rel="alternate"]').forEach((link) => {
                    const lang = link.getAttribute('hreflang');
                    if (lang === 'x-default') {
                        link.href = link.href.replace(
                            prevUrlNames[defaultLanguage],
                            this.selectedProductUrlNames[defaultLanguage]
                        );
                    } else if (this.selectedProductUrlNames[lang]) {
                        link.href = link.href.replace(prevUrlNames[lang], this.selectedProductUrlNames[lang]);
                    } else if (!this.selectedProductUrlNames[lang] && this.selectedProductUrlNames[defaultLanguage]) {
                        link.href = link.href.replace(
                            prevUrlNames[lang],
                            this.selectedProductUrlNames[defaultLanguage]
                        );
                    } else {
                        link.href = '';
                    }
                });
            }
        },

        changeSelection(source) {
            // save old data
            const prevProduct = this.selectedProduct,
                prevUrlName = this.selectedProductUrlName,
                prevUrlNames = this.selectedProductUrlNames;

            this.selectedProduct = source.id;
            this.selectedProductType = source.type;
            this.selectedProductUrlName = source.urlName || '';
            this.selectedProductUrlNames = source.urlNames || {};

            this.showLoadingAnimation = true;
            this.inputChange();

            if (this.selectedProductType === 'route_toll') {
                this.selectedProduct = this.selectedRoute;

                document.getElementById('product-name').innerText = this.$t('shop.section_page_title');
            } else if (prevProduct !== this.selectedProduct) {
                this.displayTypeOptions();

                document.getElementById('product-name').innerText = source.name;
            }

            if (this.selectedProductType === 'vignette') {
                this.paymentSubscription =
                    this.isSubscriptionEnabled && this.selectedShopProduct.subscription_by_default;
            }

            // save selection in session
            this.saveToSession('selectedProduct', 'string', this.selectedProduct);
            this.saveToSession('selectedProductType', 'string', this.selectedProductType);

            this.updateDatePicker();
            setTimeout(this.preselectRouteTollOption, 10);
            setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
                this.initToolTip();
            }, 10);

            // Check for any anchors to scroll into
            const anchorTag = this.getAnchorTag();
            let scrollSelector = null;
            if (
                (this.getWindowOuterWidth() <= this.autoScrollUpToWidth || this.forceAutoScrollOnProductSelection) &&
                (!anchorTag || this.scrollToProduct)
            ) {
                this.showPackageChange = false;
                scrollSelector = this.selectedProductType === 'vignette' ? '#vignette-fields' : '#route-toll-fields';
            } else if (this.forceAutoScrollOnProductSelection && anchorTag !== null && !this.scrollToProduct) {
                this.scrollToProduct = true;
                scrollSelector = anchorTag;
            }

            this.$nextTick(() => {
                setTimeout(
                    () => {
                        if (this.initialScroll) {
                            this.initialScroll = false;
                        }

                        let scrollY =
                            document.querySelector(scrollSelector).getBoundingClientRect().top -
                            document.getElementById('topnav').getBoundingClientRect().height;

                        if (this.selectedProductType === 'vignette') {
                            scrollY += window.scrollY;
                        }
                        window.scrollTo(0, scrollY);
                    },
                    this.initialScroll ? 50 : 100
                );
            });

            setTimeout(() => {
                this.$emit('product-selected');
                this.updateStructuredProductData();
                this.updateProductMetadata(prevUrlName, prevUrlNames);
            }, 50);

            // In the case the product has an url_name definition, we should update
            // the history of browser to give the user an history back option.
            if (
                typeof source.urlName === 'string' &&
                source.urlName.length &&
                source.urlName !== '#' &&
                window.history &&
                !(window.location.pathname.match(new RegExp(source.urlName + '$')) || []).length
            ) {
                // Default history target url
                const baseUrl = window.location.href + (window.location.href.endsWith('/') ? '' : '/');
                let historyUrl = baseUrl + source.urlName;

                // In the case we have an previous url name, we should replace the old one.
                if (typeof prevUrlName === 'string' && prevUrlName.length) {
                    historyUrl = window.location.href.replace(prevUrlName, source.urlName);
                }

                if (this.defaultSelectedOption > 0) {
                    // Do nothing. This URL is only directly reachable by the configurator.
                } else {
                    window.history.pushState('', '', historyUrl);
                }

                // In the case that the product has multiple url translations, we should
                // update the locales in the #locales-submenu.
                if (typeof source.urlNames === 'object' && (Object.keys(source.urlNames) || []).length) {
                    const navItems = document.querySelectorAll('#locales-submenu li');

                    for (const navItem of navItems) {
                        const locale = navItem.dataset.locale,
                            link = navItem.querySelector('a'),
                            oldSlugName = prevUrlNames[locale] || null,
                            newSlugName = source.urlNames[locale] || null;

                        // We're not able to handle the update of url
                        if (
                            typeof oldSlugName !== 'string' ||
                            !oldSlugName.length ||
                            typeof newSlugName !== 'string' ||
                            !newSlugName.length
                        ) {
                            return;
                        }

                        link.href = link.href.replace(oldSlugName, newSlugName);
                    }
                }
            }
        },
        getAnchorTag() {
            return window.location.hash;
        },
        changePayPalLoadingState(loading = false) {
            this.loadingPayPal = loading;
            this.$emit('paypal-status-change', loading);
        },
        changeKlarnaLoadingState(loading = false) {
            this.loadingKlarna = loading;
            this.$emit('klarna-status-change', loading);
        },
        changeSendingRequest(requesting = false) {
            this.sendingRequest = requesting;
            this.$emit('request-sending-change', requesting);
        },
        async checkForm(event) {
            event.preventDefault();

            const licenseIsValid = await this.checkLicensePlate(this.licensePlate, this.selectedCountry);

            if (licenseIsValid) {
                event.target.closest('form').submit();
            } else {
                this.licensePlateValid = false;
            }
        },
        resetLicensePlateStatus() {
            this.licensePlateValid = true;
        },
        displayRouteOptions(preSelectedOptionPresent) {
            this.selectedProduct = this.selectedRoute;

            if (!preSelectedOptionPresent) {
                this.selectedTollOption = 0;
            }

            this.availableTollOptions = this.tollProducts[this.selectedRoute].options_keyed;

            if (!preSelectedOptionPresent) {
                const alias = this;
                setTimeout(function () {
                    alias.$refs.routeTollOptions.value =
                        alias.tollProducts[alias.selectedRoute].options[0].id.toString();
                    alias.$refs.routeTollOptions.dispatchEvent(new Event('change'));
                }, 10);
            }
        },
        handleLicensePlateCheckEmitStatus(value) {
            this.licensePlateCheckStatus = value;
        },
        setDisplayLicensePlateErrorTimer() {
            if (this.timeoutLicensePlateInvalidId >= 0) {
                clearTimeout(this.timeoutLicensePlateInvalidId);
            }

            this.timeoutLicensePlateInvalidId = setTimeout(() => {
                if (!this.isSpecialLicense && this.licensePlateCheckInvalid) {
                    this.licensePlateShowError = true;
                }
            }, 2000);
        },
        getBrowserTimezone() {
            const customerTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone.includes('Kyiv')
                ? 'Europe/Kiev'
                : Intl.DateTimeFormat().resolvedOptions().timeZone;

            if (new Date().getTimezoneOffset() === Number(this.shopTimezoneUtcOffset)) {
                return null;
            }

            return customerTimezone;
        },
        handleIsSpecial(value) {
            this.isSpecialLicense = value;
        },
    },
};
</script>
<style lang="scss">
.product-order-form {
    position: relative;

    .custom-control-switch-row {
        max-width: 470px;
        // margin: 0 auto;
    }

    .disabled-element {
        position: relative;
    }

    .disabled-element:after {
        content: ' ';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 88888;

        cursor: not-allowed;
        background-color: rgba(255, 255, 255, 0.5);
    }

    .disable-form-col {
        position: relative;
    }

    .disable-form-col:after {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 10;

        background-color: rgba(255, 255, 255, 0.5);
        content: ' ';
    }

    .same-margin-bottom {
        margin-bottom: 20px;
    }

    .same-margin-top {
        margin-top: 20px;
    }

    .payment-method-container,
    .summary-container {
        padding: 0 1.31rem;
    }

    .sidebar-right-container {
        position: relative;
    }

    & > .loader-container,
    .sidebar-right-container .loader-container {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 99999;

        width: 100%;
        height: 100%;

        background-color: rgba(255, 255, 255, 0.4);
    }

    & > .loader-container.full-page-loader {
        position: fixed;
    }

    & > .loader-container #status {
        position: fixed !important;
    }

    #preloader {
        position: absolute;
        background: transparent;
    }

    .form-field-row .card {
        border: 0;
    }

    .license-plate-background {
        width: 15px;
        height: 28px;

        background-repeat: no-repeat;
        background-size: contain;
        background-position: top center;
    }

    .product-price {
        font-weight: 700;
        font-size: 30px;
    }

    .product-price.old {
        font-weight: unset;
        font-size: 18px;
        text-decoration: line-through;
    }

    input[type='checkbox'],
    input[type='radio'] {
        -webkit-transform: scale(1.2, 1.2);
    }

    input[type='text'],
    input[type='email'] {
        color: #161c2d;
    }

    .vignette-validity-until,
    .route-toll-valid-from {
        .prefix-label,
        .separator-label,
        .to-time-label {
            font-size: 1.15rem;
        }

        .from-label,
        .to-date-label {
            font-size: 1.5rem;
        }
    }

    .invalid-validity-start {
        width: 100%;
        margin-top: 0.25rem;
        font-size: 80%;
        color: #dc3545;
    }

    @media (min-width: 768px) {
        .ml-md-10 {
            margin-left: 8rem !important;
        }
    }
    @media (min-width: 992px) {
        .ml-lg-0 {
            margin-left: 0 !important;
        }
    }
}

::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: rgba(0, 0, 0, 0.3);
    opacity: 1; /* Firefox */
}

:-ms-input-placeholder, /* Internet Explorer 10-11 */
::-ms-input-placeholder /* Microsoft Edge */ {
    color: rgba(0, 0, 0, 0.3);
}

.shop-voucher-btn {
    min-width: 100px;
    height: 40px;
}

.max-width {
    width: 95%;
}

.checkboxesContainer .card-body .checkbox-item {
    display: flex;
    align-items: flex-start;
    flex-wrap: nowrap;
    gap: 10px;
}

.checkboxesContainer .card-body .checkbox-item .checkbox-text {
    flex: 1 1 auto;
    min-width: 0;
    margin-top: 0;
    padding-left: 0;
    padding-right: 0;
    text-align: justify;
}

.checkboxesContainer .card-body .notice-payment-method-delivery-period {
    display: block;
    margin-left: 45px;
}

@media (max-width: 767px) {
    .checkboxesContainer .card-body .notice-payment-method-delivery-period {
        margin-left: 35.5px;
    }
}

@media (min-width: 768px) and (max-width: 991px) {
    .checkboxesContainer .card-body .notice-payment-method-delivery-period {
        margin-left: 59.5px;
    }
}

@media (min-width: 992px) and (max-width: 1200px) {
    .checkboxesContainer .card-body .notice-payment-method-delivery-period {
        margin-left: 44.5px;
    }
}

.checkboxesContainer .card-body .notice-payment-method-delivery-period {
    text-align: justify;
}


.section.section-scroll-with-offset {
    scroll-margin-top: 120px;
}
</style>
